<template>
  <div class="model-type-card">
    <v-container fluid>
      <v-container style="margin-top: 1rem">
        <v-row class="model-header-row" align="center">
          <v-col cols="12" class="d-flex align-center justify-space-between flex-wrap" style="gap: 12px">
            <!-- <v-chip-group v-model="LLmsModel.typeLLM" column> -->
            <label style="font-size: 20px; font-weight: 700; color: #1976d2">
              <!-- {{ localEditAction != null ? (localEditAction ? 'Update' : 'Create') : 'View' }} -->
              Model
              <v-chip :color="viewOnly ? 'info' : localEditAction ? 'warning' : 'success'" variant="outlined" small>
                <v-icon left small>
                  {{ viewOnly ? 'mdi-eye-outline' : localEditAction ? 'mdi-pencil' : 'mdi-plus' }}
                </v-icon>
                {{ viewOnly ? 'View Mode' : page == 'view model' ? 'View Mode' : localEditAction != null ? (localEditAction ? 'Update Mode' : 'Create Mode') : 'Create Mode' }}
              </v-chip>
            </label>
            <div v-if="showCompareButton" class="model-header-compare-group">
              <v-menu location="bottom end">
                <template v-slot:activator="{ props }">
                  <v-btn variant="outlined" color="primary" class="model-header-compare-btn" :disabled="compareButtonDisabled" :loading="compareButtonLoading" v-bind="props">
                    <v-icon start size="18">mdi-compare-horizontal</v-icon>
                    Compare
                    <v-icon end size="18">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list density="compact">
                  <v-list-item @click="$emit('open-compare')">
                    <template v-slot:prepend>
                      <v-icon size="20">mdi-history</v-icon>
                    </template>
                    <v-list-item-title>Compare with Version</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="triggerCompareFileUpload">
                    <template v-slot:prepend>
                      <v-icon size="20">mdi-code-json</v-icon>
                    </template>
                    <v-list-item-title>Compare from File</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <input ref="compareFileInput" type="file" accept=".json" style="display: none" @change="handleCompareFileChange" />
            </div>
            <!-- </v-chip-group> -->
          </v-col>
        </v-row>
        <v-divider style="margin-top: 10px; margin-bottom: 25px"></v-divider>
        <v-form ref="form" v-model="valid" lazy-validation :disabled="viewOnly">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="mb-2">
                      <v-chip id="modelID-modelmanagement" v-if="LLmsModel.modelDisplay" :color="LLmsModel.typeLLM === 1 ? '#4CAF50' : '#1976D2'" class="model-chip ml-2" outlined>
                        <!-- <v-icon left small>
                          {{ LLmsModel.typeLLM === 1 ? 'mdi-shield-check' : 'mdi-robot' }}
                        </v-icon> -->
                        <span class="model-id">Model ID: {{ LLmsModel.modelDisplay }}</span>
                        <!-- <div v-if="LLmsModel.versioning" class="version-badge" size="x-small" label color="grey lighten-2"
                          style="position: absolute; top: 0; right: 0;">
                          <v-icon left size="x-small" color="grey darken-1">mdi-pound</v-icon>
                          <span class="version-text">{{ LLmsModel.versioning }}</span>
                        </div> -->
                      </v-chip>
                    </v-col>
                  </v-row>
                  <!-- Basic Model Information -->
                  <v-row style="margin: 10px 0px" no-gutters class="position-relative">
                    <v-col sm="2" class="d-flex align-center font-weight-bold" style="white-space: nowrap"> Basic Information </v-col>
                    <v-col sm="10" class="d-flex align-center">
                      <v-divider class="flex-grow-1"></v-divider>
                    </v-col>
                    <v-chip v-if="LLmsModel.versioning" class="version-badge" size="x-small" label color="grey lighten-2" style="position: absolute; top: -10px; right: 0">
                      <v-icon left size="x-small" color="grey darken-1" style="padding-right: 10px">mdi-tag-outline</v-icon>
                      <span class="version-text">Version: {{ LLmsModel.versioning }}</span>
                    </v-chip>
                  </v-row>
                  <v-row>
                    <!-- Model Type & Name Card -->
                    <v-col cols="12">
                      <v-card variant="outlined" class="mb-0">
                        <v-card-text>
                          <v-row>
                            <!-- Model Type and model name-->
                            <v-col cols="12" md="4" style="margin-top: 5px">
                              <v-row>
                                <v-col cols="auto">
                                  <span class="text-subtitle-1 font-weight-medium">Model Type</span>
                                </v-col>
                                <v-col cols="auto">
                                  <v-btn-toggle v-model="LLmsModel.typeLLM" style="margin-top: -5px" mandatory class="model-type-toggle" density="compact">
                                    <v-btn id="button-bot-modelmanagement" :value="0" class="model-type-btn" :disabled="localEditAction">Bot</v-btn>
                                    <v-btn id="button-guardrail-modelmanagement" :value="1" class="model-type-btn" :disabled="localEditAction">Guard Rail</v-btn>
                                  </v-btn-toggle>
                                </v-col>
                              </v-row>
                            </v-col>

                            <!-- Model Name -->
                            <v-col cols="12" md="8">
                              <v-text-field
                                id="modelname-field-modelmanagement"
                                v-model="LLmsModel.modelName"
                                label="Model Name*"
                                :rules="[rules.required]"
                                required
                                density="compact"
                                variant="outlined"
                                placeholder="Enter a unique model name"
                                hint="A unique identifier for your model"
                                persistent-hint
                              >
                                <!-- <template v-slot:append>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon
                                        size="small"
                                        color="grey"
                                        v-bind="props"
                                        >mdi-information</v-icon
                                      >
                                    </template>
                                    <span>{{ $t("_InfoModelName") }}</span>
                                  </v-tooltip>
                                </template> -->
                              </v-text-field>
                            </v-col>

                            <!-- Description - Full Width -->
                            <v-col cols="12" class="mt-3">
                              <v-textarea
                                id="description-textarea-modelmanagement"
                                v-model="LLmsModel.description"
                                label="Description"
                                density="compact"
                                variant="outlined"
                                auto-grow
                                rows="2"
                                placeholder="Describe the model's purpose"
                                hint="Brief description of what this model does"
                                persistent-hint
                                class="description-field"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Model Configuration -->
                  <v-card class="mb-1" variant="outlined">
                    <v-row style="margin: 10px 0px" no-gutters>
                      <v-col sm="2" class="d-flex align-center font-weight-bold" style="white-space: nowrap"> Model Configuration </v-col>
                      <v-col sm="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-90"></v-divider>
                      </v-col>
                    </v-row>
                    <v-card-text>
                      <v-row density="compact">
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            id="provider-autocomplete-modelmanagement"
                            v-model="LLmsModel.provider"
                            :items="listDDProvider"
                            item-title="providerName"
                            item-value="providerName"
                            prepend-inner-icon="mdi-cloud-outline"
                            label="Provider*"
                            :rules="[rules.required]"
                            required
                            density="compact"
                            variant="outlined"
                            @update:model-value="(changeProvider(LLmsModel.provider), clearLLM())"
                            hint="Select AI service provider"
                            persistent-hint
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-autocomplete
                            id="model-autocomplete-modelmanagement"
                            v-model="LLmsModel.model"
                            :items="DDModelShow"
                            item-title="modelDisplay"
                            item-value="modelName"
                            label="Model*"
                            :rules="[rules.required, (value) => (!value || value.split('')[0] !== '|' ? true : 'Please select model')]"
                            required
                            density="compact"
                            variant="outlined"
                            @update:model-value="changeModel(LLmsModel.model)"
                            prepend-inner-icon="mdi-brain"
                            :disabled="!LLmsModel.provider"
                            hint="Select specific model version"
                            persistent-hint
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            id="model-extension-modelmanagement"
                            v-model="LLmsModel.extension"
                            label="Extension"
                            density="compact"
                            variant="outlined"
                            prepend-inner-icon="mdi-puzzle-outline"
                            hint="Optional model extension"
                            persistent-hint
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Additional Settings -->
                  <v-card variant="outlined">
                    <v-row style="margin: 10px 0px" no-gutters>
                      <v-col sm="2" class="d-flex align-center font-weight-bold" style="white-space: nowrap"> Additional Settings </v-col>
                      <v-col sm="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-90"></v-divider>
                      </v-col>
                    </v-row>
                    <v-card-text>
                      <v-row density="compact">
                        <v-col cols="12" md="4">
                          <v-select
                            id="gender-autocomplete-modelmanagement"
                            v-model="LLmsModel.gender"
                            :items="DDGender"
                            item-title="name"
                            item-value="id"
                            label="Gender"
                            density="compact"
                            variant="outlined"
                            prepend-inner-icon="mdi-account"
                          />
                        </v-col>

                        <!-- <v-col cols="12" md="3">
                          <v-text-field v-model="LLmsModel.versioning" label="Version" disabled density="compact" variant="outlined"
                          prepend-inner-icon="mdi-tag" :rules="[rules.required]"></v-text-field>
                        </v-col> -->

                        <v-col cols="12" md="4">
                          <v-text-field
                            id="typingspeed-field-modelmanagement"
                            v-model.number="LLmsModel.typingSpeed"
                            label="Typing Speed"
                            type="number"
                            min="0"
                            density="compact"
                            variant="outlined"
                            prepend-inner-icon="mdi-keyboard-outline"
                            @keypress="isNumberpositive($event)"
                            hint="Speed of text generation"
                            persistent-hint
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            id="maxinputlength-field-modelmanagement"
                            v-model.number="LLmsModel.maximumChatInput"
                            label="Max Input Length"
                            type="number"
                            min="0"
                            max="999999"
                            density="compact"
                            variant="outlined"
                            prepend-inner-icon="mdi-text-box-outline"
                            :rules="[rules.required]"
                            @keypress="maxNumberpositive($event)"
                            hint="Maximum characters allowed"
                            persistent-hint
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-container>
                <transition name="fade">
                  <div v-if="txtToImgChecker" class="image-settings-container mb-4" style="width: 100%">
                    <!-- Enhanced Header -->
                    <v-card variant="outlined" class="image-settings-card">
                      <v-card-title class="image-header d-flex align-center py-4">
                        <v-icon color="blue-grey darken-2 mr-5" size="28">mdi-image-edit</v-icon>
                        <div class="flex-grow-1">
                          <h3 class="text-h6 mb-1">Image Generation Settings</h3>
                          <p class="text-caption text-grey-darken-1 mb-0">Configure AI image generation parameters</p>
                        </div>
                      </v-card-title>

                      <v-divider></v-divider>

                      <!-- Enhanced Content -->
                      <v-card-text class="pa-6">
                        <v-row class="image-settings-row">
                          <!-- Style Selection -->
                          <v-col cols="12" md="6">
                            <div class="setting-group">
                              <div class="setting-label mb-3">
                                <v-icon color="indigo" size="small" class="mr-2">mdi-palette</v-icon>
                                <span class="font-weight-medium">Image Style</span>
                                <v-chip size="x-small" color="red" class="ml-2">Required</v-chip>
                              </div>

                              <v-select
                                id="imagestyle-select-modelmanagement"
                                v-model="LLmsModel.styleImage"
                                :items="imageStyleOptions"
                                item-title="text"
                                item-value="value"
                                :rules="[rules.required]"
                                variant="outlined"
                                density="compact"
                                required
                                class="enhanced-select style-select"
                                placeholder="Choose image style"
                                prepend-inner-icon="mdi-brush"
                              >
                                <template v-slot:selection="{ item }">
                                  <div class="d-flex align-center">
                                    <v-icon :color="item.raw.value === 'natural' ? 'green' : 'orange'" size="small" class="mr-2">
                                      {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                    </v-icon>
                                    <span class="font-weight-medium">{{ item.raw.text }}</span>
                                  </div>
                                </template>

                                <template v-slot:item="{ props, item }">
                                  <v-list-item v-bind="props" class="style-item">
                                    <template v-slot:prepend>
                                      <v-avatar :color="item.raw.value === 'natural' ? 'green lighten-4' : 'orange lighten-4'" size="32">
                                        <v-icon size="16" color="white">
                                          {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                        </v-icon>
                                      </v-avatar>
                                    </template>
                                    <template v-slot:title>
                                      <span class="font-weight-medium">{{ item.raw.text }}</span>
                                    </template>
                                    <template v-slot:subtitle>
                                      <span class="text-caption">
                                        {{ item.raw.value === 'natural' ? 'Realistic and natural looking' : 'Vibrant and dramatic style' }}
                                      </span>
                                    </template>
                                  </v-list-item>
                                </template>
                              </v-select>

                              <div>
                                <v-icon size="small" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                <span class="text-caption text-grey-darken-1">Choose the artistic style for generated images</span>
                              </div>
                            </div>
                          </v-col>

                          <!-- Quality Setting -->
                          <v-col cols="12" md="3">
                            <div class="setting-group">
                              <div class="setting-label mb-3">
                                <v-icon color="blue" size="small" class="mr-2">mdi-quality-high</v-icon>
                                <span class="font-weight-medium">Quality</span>
                              </div>

                              <v-text-field
                                label="Quality Level"
                                variant="outlined"
                                density="compact"
                                disabled
                                v-model="LLmsModel.quality"
                                prepend-inner-icon="mdi-diamond-stone"
                                class="quality-field"
                                readonly
                              >
                                <template v-slot:append-inner>
                                  <v-icon size="small" color="grey" v-bind="props"> mdi-lock </v-icon>
                                </template>
                              </v-text-field>
                            </div>
                          </v-col>

                          <!-- Resolution Setting -->
                          <v-col cols="12" md="3">
                            <div class="setting-group">
                              <div class="setting-label mb-3">
                                <v-icon color="indigo" size="small" class="mr-2">mdi-monitor-screenshot</v-icon>
                                <span class="font-weight-medium">Resolution</span>
                              </div>

                              <v-text-field
                                label="Image Size"
                                variant="outlined"
                                density="compact"
                                disabled
                                v-model="LLmsModel.resolution"
                                value="1024x1024"
                                prepend-inner-icon="mdi-aspect-ratio"
                                class="resolution-field"
                                readonly
                              >
                                <template v-slot:append-inner>
                                  <v-icon size="small" color="grey" v-bind="props"> mdi-lock </v-icon>
                                </template>
                              </v-text-field>

                              <div>
                                <v-icon size="small" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                <span class="text-caption text-grey-darken-1">Image resolution in pixels</span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>
                </transition>
              </v-row>

              <v-row align="center">
                <v-container fluid class="pa-0">
                  <!-- Response Options Card -->
                  <v-card outlined class="mb-4 rounded-lg elevation-0" style="border: 0">
                    <v-card-title class="subtitle-1 py-2 d-flex align-center">
                      <v-icon left color="primary" size="24" class="mr-2">mdi-tune</v-icon>
                      Response Options
                      <v-divider class="ml-4 flex-grow-1"></v-divider>
                    </v-card-title>

                    <v-card-text class="options-section">
                      <v-row dense>
                        <!-- Stream Option -->
                        <v-col cols="12" md="4" class="py-2">
                          <v-card class="option-card d-flex flex-column" :class="{ 'option-active': LLmsModel.isStream }" flat height="100%" min-height="90px">
                            <div class="d-flex justify-space-between align-start">
                              <div class="option-header">
                                <div class="d-flex align-center">
                                  <v-icon color="primary" size="20" class="mr-2">mdi-text-box-outline</v-icon>
                                  <span class="font-weight-medium">Stream Response</span>
                                  <v-tooltip top max-width="300">
                                    <template v-slot:activator="{ props: attrs, on }">
                                      <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t('_InfoStream') }}</span>
                                  </v-tooltip>
                                </div>
                                <div class="grey--text text-caption mt-1">Enable progressive text generation</div>
                              </div>
                              <v-switch id="switch-stream-ModelManagement" v-model="LLmsModel.isStream" color="primary" hide-details dense class="mt-0" inset></v-switch>
                            </div>
                          </v-card>
                        </v-col>

                        <!-- Feedback Option -->
                        <v-col cols="12" md="4" class="py-2">
                          <v-card class="option-card d-flex flex-column" :class="{ 'option-active': LLmsModel.isFeedback }" flat height="100%" min-height="90px">
                            <div class="d-flex justify-space-between align-start">
                              <div class="option-header">
                                <div class="d-flex align-center">
                                  <v-icon color="primary" size="20" class="mr-2">mdi-thumbs-up-down-outline</v-icon>
                                  <span class="font-weight-medium">Collect Feedback</span>
                                  <v-tooltip top max-width="300">
                                    <template v-slot:activator="{ props: attrs, on }">
                                      <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t('_InfoFeedback') }}</span>
                                  </v-tooltip>
                                </div>
                                <div class="grey--text text-caption mt-1">Allow users to rate responses</div>
                              </div>
                              <v-switch id="switch-feedback-ModelManagement" v-model="LLmsModel.isFeedback" color="primary" hide-details dense class="mt-0" inset></v-switch>
                            </div>
                          </v-card>
                        </v-col>
                        <!-- LLM Changing -->
                        <v-col cols="12" md="4" class="py-2">
                          <v-card class="option-card d-flex flex-column" :class="{ 'option-active': LLmsModel.isAllowLLMChange }" flat height="100%" min-height="90px">
                            <div class="d-flex justify-space-between align-start">
                              <div class="option-header">
                                <div class="d-flex align-center">
                                  <v-icon color="primary" size="20" class="mr-2">mdi-swap-horizontal</v-icon>
                                  <span class="font-weight-medium">LLM Selection</span>
                                  <v-tooltip top max-width="300">
                                    <template v-slot:activator="{ props: attrs, on }">
                                      <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                    </template>
                                    <span>Allow users to change the LLM model during chat sessions</span>
                                  </v-tooltip>
                                </div>
                                <div class="grey--text text-caption mt-1">Allow model switching in chat</div>
                              </div>
                              <v-switch id="llm-selection-switch-modelmanagement" v-model="LLmsModel.isAllowLLMChange" color="primary" hide-details dense class="mt-0" inset></v-switch>
                            </div>
                          </v-card>
                        </v-col>

                        <!-- Reasoning Effort -->
                        <v-col cols="12" md="4" class="py-2">
                          <transition name="fade">
                            <v-card v-if="showReasoningEffort" class="option-card d-flex flex-column" :class="{ 'option-active': LLmsModel.reasoningEffort }" flat height="100%" min-height="90px">
                              <div class="d-flex justify-space-between align-start">
                                <div class="option-header mb-auto">
                                  <div class="d-flex align-center">
                                    <v-icon color="primary" size="20" class="mr-2">mdi-lightbulb-on</v-icon>
                                    <span class="font-weight-medium">Reasoning Effort</span>
                                    <v-tooltip top max-width="300">
                                      <template v-slot:activator="{ props }">
                                        <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                      </template>
                                      <span>Level of reasoning depth for responses</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </div>

                              <v-select
                                id="reasoning-ModelManagement"
                                v-model="LLmsModel.reasoningEffort"
                                :items="reasonOptions"
                                :rules="showReasoningEffort ? [rules.required] : [rules.notRequired]"
                                item-title="text"
                                item-value="value"
                                density="compact"
                                variant="outlined"
                                hide-details="auto"
                                placeholder="Select level"
                                background-color="white"
                                prepend-inner-icon="mdi-message-reply-text"
                                class="mt-1 reasoning-select"
                              >
                                <template v-slot:selection="{ item }">
                                  <div class="d-flex align-center">
                                    <v-chip size="small" :color="getReasoningColor(item.raw.value)" text-color="white" class="px-3 reasoning-chip">
                                      {{ item.raw.text }}
                                    </v-chip>
                                  </div>
                                </template>
                              </v-select>
                            </v-card>
                          </transition>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Media & Context Card -->
                  <v-card outlined class="mb-4 rounded-lg elevation-0" style="border: 0">
                    <v-card-title class="subtitle-1 py-2 d-flex align-center">
                      <v-icon left color="primary" size="24" class="mr-2">mdi-image-filter-none</v-icon>
                      Media & Context
                      <v-divider class="ml-4 flex-grow-1"></v-divider>
                    </v-card-title>

                    <v-card-text>
                      <v-row dense>
                        <!-- Image Upload Settings -->
                        <v-col cols="12" md="6" class="py-2">
                          <v-hover>
                            <template v-slot:default="{ hover }">
                              <v-card
                                class="option-card d-flex flex-column"
                                :class="{
                                  'on-hover': hover,
                                  'option-active': LLmsModel.isAllowImage && showFileUpload,
                                }"
                                flat
                                height="100%"
                                :min-height="LLmsModel.isAllowImage && showFileUpload ? '148px' : '90px'"
                              >
                                <div class="d-flex justify-space-between align-start">
                                  <div class="option-header">
                                    <div class="d-flex align-center">
                                      <v-icon color="primary" size="22" class="mr-2">mdi-image-plus-outline</v-icon>
                                      <span class="font-weight-medium">Image Upload</span>
                                      <v-tooltip location="top" max-width="300">
                                        <template v-slot:activator="{ props }">
                                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('_InfoImageUpload') }}</span>
                                      </v-tooltip>
                                    </div>
                                    <div class="grey--text text-caption mt-1">Allow users to upload images for analysis</div>
                                  </div>
                                  <v-switch
                                    id="fileupload-checkbox-modelmanagement"
                                    v-model="LLmsModel.isAllowImage"
                                    :disabled="!showFileUpload"
                                    color="primary"
                                    hide-details
                                    dense
                                    class="mt-0"
                                    inset
                                  ></v-switch>
                                </div>

                                <transition name="fade">
                                  <div v-if="LLmsModel.isAllowImage && showFileUpload" class="mt-auto pt-3 additional-content">
                                    <v-text-field
                                      id="fileuploadlimit-field-modelmanagement"
                                      label="Maximum file size"
                                      @keypress="validateNumber($event)"
                                      @paste="validateNumber($event)"
                                      v-model.number="LLmsModel.fileUploadLimit"
                                      density="compact"
                                      variant="outlined"
                                      hide-details="auto"
                                      class="upload-limit-field enhanced-text-field"
                                      background-color="white"
                                      hint="Recommended: 1024KB for most cases"
                                      persistent-hint
                                      color="primary"
                                      :rules="[rules.required]"
                                    >
                                      <template v-slot:prepend-inner>
                                        <v-icon color="primary" size="22" class="mr-1"> mdi-file-document-outline </v-icon>
                                      </template>

                                      <template v-slot:append-inner>
                                        <v-chip size="small" color="blue-grey lighten-1" text-color="white" class="file-size-chip"> KB </v-chip>
                                      </template>

                                      <template v-slot:append>
                                        <v-tooltip location="top" max-width="300">
                                          <template v-slot:activator="{ props }">
                                            <v-icon small color="grey-darken-1" v-bind="props" class="info-icon-enhanced"> mdi-information-outline </v-icon>
                                          </template>
                                          <span>{{ $t('_InfoMaximumFileUpload') }}</span>
                                        </v-tooltip>
                                      </template>
                                    </v-text-field>
                                  </div>
                                </transition>
                              </v-card>
                            </template>
                          </v-hover>
                        </v-col>

                        <!-- Time Settings -->
                        <v-col cols="12" md="6" class="py-2">
                          <v-hover>
                            <template v-slot:default="{ hover }">
                              <v-card
                                class="option-card d-flex flex-column"
                                :class="{
                                  'on-hover': hover,
                                  'option-active': LLmsModel.enableTime,
                                }"
                                flat
                                height="100%"
                                :min-height="LLmsModel.enableTime ? '148px' : '90px'"
                              >
                                <div class="d-flex justify-space-between align-start">
                                  <div class="option-header">
                                    <div class="d-flex align-center">
                                      <v-icon color="primary" size="22" class="mr-2">mdi-clock-outline</v-icon>
                                      <span class="font-weight-medium">Time Context</span>
                                      <v-tooltip location="top" max-width="300">
                                        <template v-slot:activator="{ props }">
                                          <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{ $t('_InfoEnableTime') }}</span>
                                      </v-tooltip>
                                    </div>
                                    <div class="grey--text text-caption mt-1">Enable time awareness in responses</div>
                                  </div>
                                  <v-switch id="Enabletime-modelmanagement" v-model="LLmsModel.enableTime" color="primary" hide-details dense class="mt-0" inset></v-switch>
                                </div>

                                <transition name="fade">
                                  <div v-if="LLmsModel.enableTime" style="margin-top: 12px" class="additional-content">
                                    <v-select
                                      id="timezone-modelmanagement"
                                      v-model="LLmsModel.timeZone"
                                      :items="DDTimeZone"
                                      item-title="name"
                                      item-value="value"
                                      label="Time Zone"
                                      density="compact"
                                      variant="outlined"
                                      hide-details="auto"
                                      background-color="white"
                                      class="timezone-field enhanced-select"
                                      placeholder="Select your timezone"
                                    >
                                      <template v-slot:prepend>
                                        <v-icon size="32" color="primary" style="opacity: 1"> mdi-earth </v-icon>
                                      </template>

                                      <template v-slot:selection="{ item }">
                                        <div style="padding: 7px" class="timezone-selection d-flex align-center">
                                          <v-icon small color="primary" class="mr-2">mdi-map-marker</v-icon>
                                          <span class="font-weight-medium">{{ item.raw.name }}</span>
                                          <v-chip size="x-small" color="grey-darken-1" text-color="white" class="ml-2 timezone-code">
                                            {{ item.raw.value.split('/')[1].replace('_', ' ') }}
                                          </v-chip>
                                        </div>
                                      </template>

                                      <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props" class="timezone-item">
                                          <template v-slot:title>
                                            <div class="timezone-item-content">
                                              <span class="timezone-country font-weight-medium" style="margin-left: 5px">{{ item.raw.name }}</span>
                                              <div class="timezone-details d-flex align-center mt-1">
                                                <v-chip size="x-small" color="grey-darken-1" text-color="white" class="timezone-code">{{ item.raw.value.replace('_', ' ') }} </v-chip>
                                              </div>
                                            </div>
                                          </template>

                                          <!-- <template v-slot:append>
                                            <v-icon size="16" color="grey-lighten-1">mdi-chevron-right</v-icon>
                                          </template> -->
                                        </v-list-item>
                                      </template>
                                    </v-select>
                                  </div>
                                </transition>
                              </v-card>
                            </template>
                          </v-hover>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-row>
              <v-row align="center">
                <v-container fluid class="pa-0">
                  <!-- Flow Selection Card -->
                  <v-card outlined class="mb-4 rounded-lg elevation-0 flow-selection-card" style="border: 0">
                    <v-card-title class="subtitle-1 py-3 d-flex align-center flow-card-header">
                      <v-avatar size="32" color="primary" variant="tonal" class="mr-3">
                        <v-icon color="primary" size="20">mdi-chart-timeline-variant-shimmer</v-icon>
                      </v-avatar>
                      <div class="flex-grow-1">
                        <span class="text-h6 font-weight-medium">Flow Configuration</span>
                        <div class="text-caption text-grey-darken-1 mt-1">Configure workflow integration for this model</div>
                      </div>
                      <v-divider class="ml-4 flex-grow-1"></v-divider>
                    </v-card-title>

                    <v-card-text class="pa-6">
                      <v-row dense>
                        <v-col cols="12" md="6">
                          <div class="flow-selector-wrapper">
                            <v-select
                              id="flow-dropdown-modelmanagement"
                              v-model="LLmsModel.flowGroupID"
                              :items="flowDropdown"
                              item-title="name"
                              item-value="flowGroupID"
                              label="Select Flow"
                              density="comfortable"
                              variant="outlined"
                              prepend-inner-icon="mdi-flow-chart"
                              clearable
                              hint="Choose the workflow integration for this model"
                              persistent-hint
                              class="flow-select-enhanced"
                              placeholder="Choose a flow..."
                            >
                              <template v-slot:selection="{ item }">
                                <div class="d-flex align-center flow-selection-display">
                                  <v-icon color="primary" size="20" class="mr-2">mdi-chart-timeline-variant-shimmer</v-icon>
                                  <span class="font-weight-medium">{{ item.raw.name }}</span>
                                </div>
                              </template>

                              <template v-slot:item="{ props, item }">
                                <v-list-item v-bind="props" class="flow-list-item">
                                  <template v-slot:prepend>
                                    <v-avatar size="32" color="primary" variant="tonal">
                                      <v-icon size="16" color="primary">mdi-chart-timeline-variant-shimmer</v-icon>
                                    </v-avatar>
                                  </template>
                                  <template v-slot:title>
                                    <span class="font-weight-medium">{{ item.raw.name }}</span>
                                  </template>
                                  <template v-slot:subtitle>
                                    <span class="text-caption text-grey-darken-1"> Flow ID: {{ item.raw.flowGroupID }} </span>
                                  </template>
                                </v-list-item>
                              </template>
                            </v-select>
                          </div>
                        </v-col>

                        <!-- Flow Status Display -->
                        <v-col cols="12" md="6">
                          <div class="flow-status-display">
                            <div class="d-flex align-center mb-2">
                              <v-icon color="grey-darken-1" size="20" class="mr-2">mdi-information-outline</v-icon>
                              <span class="text-subtitle-2 font-weight-medium">Flow Status</span>
                            </div>
                            <div class="flow-status-content">
                              <div v-if="LLmsModel.flowGroupID" class="flow-connected">
                                <v-chip color="success" variant="tonal" size="small" prepend-icon="mdi-check-circle" class="mb-2"> Flow Connected </v-chip>
                                <div class="text-caption text-grey-darken-1">Model is integrated with selected workflow</div>
                              </div>
                              <div v-else class="flow-disconnected">
                                <v-chip color="warning" variant="tonal" size="small" prepend-icon="mdi-alert-circle" class="mb-2"> No Flow Selected </v-chip>
                                <div class="text-caption text-grey-darken-1">Select a flow to enable workflow integration</div>
                              </div>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-row>
              <v-row class="my-4">
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-card class="publication-status-card-full" elevation="0" variant="outlined">
                    <v-card-text class="pa-0">
                      <div class="status-wrapper-full">
                        <!-- Header Section -->
                        <div class="status-header-full">
                          <div class="d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                              <v-avatar size="48" :color="LLmsModel.isPublish ? 'success' : 'warning'" variant="tonal" class="mr-4">
                                <v-icon :icon="LLmsModel.isPublish ? 'mdi-rocket-launch' : 'mdi-file-document-edit'" size="24" :color="LLmsModel.isPublish ? 'success' : 'warning'"></v-icon>
                              </v-avatar>

                              <div>
                                <h3 class="text-h6 font-weight-medium mb-1">Publication Status</h3>
                                <p class="text-body-2 text-grey-darken-1 mb-0">Control model visibility and availability across all platforms</p>
                              </div>
                            </div>

                            <!-- Status Badge -->
                            <v-chip
                              :color="LLmsModel.isPublish ? 'success' : 'warning'"
                              :variant="LLmsModel.isPublish ? 'elevated' : 'tonal'"
                              size="large"
                              class="status-chip-large"
                              style="min-width: 150px"
                            >
                              <v-icon :icon="LLmsModel.isPublish ? 'mdi-check-circle' : 'mdi-clock-outline'" size="18" class="mr-2"></v-icon>
                              {{ LLmsModel.isPublish ? 'PUBLISHED' : 'DRAFT' }}
                            </v-chip>
                          </div>
                        </div>

                        <v-divider class="my-4"></v-divider>

                        <!-- Main Content Section -->
                        <v-row class="status-content-section">
                          <!-- Status Info -->
                          <v-col cols="12" md="4">
                            <div class="status-info-card">
                              <h4 class="text-subtitle-1 font-weight-medium mb-2">Status Info</h4>
                              <div class="status-details">
                                <div class="status-item">
                                  <v-icon size="16" :color="LLmsModel.isPublish ? 'success' : 'warning'" class="mr-2"> mdi-information-outline </v-icon>
                                  <span class="text-body-2">
                                    {{ LLmsModel.isPublish ? 'Model is live and available for users' : 'Model is saved but not accessible to users' }}
                                  </span>
                                </div>

                                <div class="status-item mt-2">
                                  <v-icon size="16" color="grey-darken-1" class="mr-2"> mdi-account-group-outline </v-icon>
                                  <span class="text-body-2">
                                    {{ LLmsModel.isPublish ? 'Public Access' : 'Admin Only' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <!-- Model Performance Stats -->
                          <v-col cols="12" md="4">
                            <div class="status-info-card">
                              <h4 class="text-subtitle-1 font-weight-medium mb-2">Model Info</h4>
                              <div class="model-stats">
                                <div class="stat-item">
                                  <span class="stat-label">Version:</span>
                                  <span class="stat-value">{{ LLmsModel.versioning || 'v1.0' }}</span>
                                </div>
                                <div class="stat-item">
                                  <span class="stat-label">Type:</span>
                                  <span class="stat-value">{{ LLmsModel.typeLLM === 1 ? 'Guard Rail' : 'Bot' }}</span>
                                </div>
                                <div class="stat-item">
                                  <span class="stat-label">Provider:</span>
                                  <span class="stat-value">{{ LLmsModel.provider || 'N/A' }}</span>
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <!-- Toggle Control -->
                          <v-col cols="12" md="4">
                            <div class="status-control-card">
                              <h4 class="text-subtitle-1 font-weight-medium mb-3">Publication Control</h4>
                              <div class="toggle-container publish-card">
                                <v-switch
                                  id="publication-status-switch"
                                  v-model="LLmsModel.isPublish"
                                  :color="LLmsModel.isPublish ? 'success' : 'warning'"
                                  class="status-switch-large"
                                  :class="LLmsModel.isPublish ? 'status-switch-active' : 'status-switch-inactive'"
                                  hide-details
                                  inset
                                  density="comfortable"
                                >
                                  <template v-slot:label>
                                    <div class="switch-label-container">
                                      <span class="switch-label-large">
                                        {{ LLmsModel.isPublish ? 'Published' : 'Draft' }}
                                      </span>
                                      <span class="switch-sublabel">
                                        {{ LLmsModel.isPublish ? 'Users can access' : 'Testing mode' }}
                                      </span>
                                    </div>
                                  </template>
                                </v-switch>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="my-4">
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-expansion-panels multiple v-model="panel" class="modern-panels" :elevation="3">
                <v-expansion-panel>
                  <template v-slot:title>
                    <div class="d-flex align-center panel-header py-2">
                      <v-icon icon="mdi-book-open-page-variant" class="me-3" color="#1976D2"></v-icon>
                      <span class="header">Knowledge</span>
                      <!-- <v-icon id="icon-knowledge-modelmanagement" class="ml-auto">{{ panel.includes(0) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon> -->
                    </div>
                  </template>
                  <template v-slot:text>
                    <v-row style="margin: 5px 0px">
                      <v-col sm="12" md="2"> Documents </v-col>
                      <v-col sm="12" md="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 25px">
                      <v-col cols="12" sm="12" md="6">
                        <v-autocomplete
                          id="documentname-autocomplete-modelmanagement"
                          :label="'Document Name'"
                          :items="DDVector"
                          item-title="name"
                          item-value="name"
                          density="compact"
                          chips
                          deletable-chips
                          multiple
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.vectordbName"
                          :rules="[rules.required]"
                          :disabled="LLmsModel.provider == null"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon id="infovectorDBname-modelmanagement" size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoVectorDBName') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                        <!-- App Knowledge Center: picker แสดงเฉพาะของ Center / ดึงรายการไม่ได้ (โหมดปิดไม่แสดง) -->
                        <v-alert v-if="kccCenterMode" :type="kccDocsUnavailable ? 'warning' : 'info'" variant="tonal"
                          density="compact" class="mt-2 text-caption">
                          {{ $t(kccDocsUnavailable || 'kccPickerCenterOnly') }}
                        </v-alert>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-autocomplete
                          id="text-replacement-modelmanagement"
                          :label="'Text Replacement'"
                          :items="DDGroupReplace"
                          item-title="name"
                          density="compact"
                          chips
                          deletable-chips
                          item-value="id"
                          multiple
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.groupReplaceID"
                          :disabled="LLmsModel.provider == null"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon id="InfoGroupReplaceText-modelmanegement" text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoGroupReplaceText') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          id="top-n-chunks-field-modelmanagement"
                          :label="'Top-N Chunks'"
                          density="compact"
                          :disabled="LLmsModel.vectordbName.length == 0"
                          v-model="LLmsModel.topVDB"
                          clearable
                          variant="outlined"
                          @keypress="isNumberpositive($event)"
                          :rules="[checkValidate()]"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon id="infotopVDB-modelmanagement" text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoTopVDB') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          id="cosine-similarity-modelmanagement"
                          :label="'Cosine Similarity'"
                          density="compact"
                          :disabled="LLmsModel.vectordbName.length == 0"
                          v-model="LLmsModel.Cosine"
                          clearable
                          variant="outlined"
                          @keypress="isNumber($event)"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoCosine') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="margin: 5px 0px">
                      <v-col sm="12" md="2"> Database </v-col>
                      <v-col sm="12" md="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          id="tablename-autocomplete-modelmanagement"
                          :label="'Table Name'"
                          :items="listDataIntegration"
                          item-title="dataName"
                          item-value="id"
                          density="compact"
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.DataIntegrationID"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoDataIntegration') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          id="sqlextractionmodel-autocomplete-modelmanagement"
                          :label="'SQL Extraction Model'"
                          :items="listSqlExtract"
                          item-title="name"
                          item-value="modelDisplayID"
                          density="compact"
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.SqlModelID"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoSQLExtractStatement') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="12" md="12">
                        <v-textarea
                          id="promptsqlnodata-textarea-modelmanagement"
                          variant="outlined"
                          rows="7"
                          v-model="LLmsModel.promptSqlNoData"
                          label="Prompt for No data"
                          placeholder="Enter the Prompt when No data."
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="margin: 5px 0px">
                      <v-col sm="12" md="2"> Products </v-col>
                      <v-col sm="12" md="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 25px">
                      <v-col cols="12" sm="12" md="6">
                        <v-autocomplete
                          :label="'Product Group Name'"
                          :items="DDProductGroup"
                          item-title="name"
                          density="compact"
                          chips
                          deletable-chips
                          item-value="id"
                          multiple
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.productGroupID"
                          :disabled="LLmsModel.provider == null"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoGroupReplaceText') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          id="top-n-chunks-field-modelmanagement"
                          :label="'Top-N Chunks'"
                          density="compact"
                          :disabled="LLmsModel.productGroupID.length == 0"
                          v-model="LLmsModel.productTopVDB"
                          clearable
                          variant="outlined"
                          @keypress="isNumberpositive($event)"
                          :rules="[checkProductValidate()]"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoTopVDB') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          :label="'Cosine Similarity'"
                          density="compact"
                          :disabled="LLmsModel.productGroupID.length == 0"
                          v-model="LLmsModel.productCosine"
                          clearable
                          variant="outlined"
                          @keypress="isNumber($event)"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoCosine') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel>
                <v-expansion-panel>
                  <template v-slot:title>
                    <div class="d-flex align-center panel-header py-2">
                      <v-icon icon="mdi-brain" class="me-3" color="#00BCD4"></v-icon>
                      <span class="header">Memory Settings</span>
                      <!-- <v-icon id="icon-knowledge-modelmanagement" class="ml-auto">{{ panel.includes(0) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon> -->
                    </div>
                  </template>
                  <template v-slot:text>
                    <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          id="turn-memory-modelmanagement"
                          :label="'Turn'"
                          clearable
                          variant="outlined"
                          density="compact"
                          v-model="LLmsModel.historyCount"
                          @keypress="isNumberpositive($event)"
                          min="0"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoTurn') }} </span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          id="duration-memory-modelmanagement"
                          :label="'Duration (min)'"
                          clearable
                          variant="outlined"
                          density="compact"
                          v-model="LLmsModel.historyMinute"
                          @keypress="isNumber($event)"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoMinute') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          id="short-term-memory-modelmanagement"
                          :label="'Short-Term Memory'"
                          clearable
                          density="compact"
                          variant="outlined"
                          v-model="LLmsModel.Len_ShortMemory"
                          @keypress="numericKey"
                          min="1"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoShortMemory') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                          id="checkbox-longterm-memory-modelmanagement"
                          class="mt-1"
                          density="compact"
                          :label="'Long-Term Memory'"
                          v-model="LLmsModel.IsLongTerm_Memory"
                          :disabled="LLmsModel.provider == 'Google'"
                          hide-details
                        >
                          <!-- :value="
                            LLmsModel.provider == 'Google'
                              ? false
                              : LLmsModel.IsLongTerm_Memory
                          " -->
                          <template v-slot:label>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <label v-bind="props">Long-Term Memory</label>
                              </template>
                              <span>{{ $t('_InfoLongtermMemory') }}</span>
                            </v-tooltip>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          id="sequence-field-modelmanagement"
                          :label="'Sequence'"
                          density="compact"
                          :disabled="LLmsModel.IsChainMassage == null || LLmsModel.IsChainMassage == ''"
                          v-model="LLmsModel.LenChainMassage"
                          clearable
                          variant="outlined"
                          @keypress="isNumberpositive($event)"
                          :rules="[checkValidate()]"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoSequence') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          id="duration-field-modelmanagement"
                          :label="'Duration (s)'"
                          density="compact"
                          :disabled="LLmsModel.IsChainMassage == null || LLmsModel.IsChainMassage == ''"
                          v-model="LLmsModel.TimeSecondChainMassage"
                          clearable
                          variant="outlined"
                          @keypress="isNumberpositive($event)"
                          :rules="[checkValidate()]"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoTimeSeconds') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-checkbox
                          id="enablemulti-turninput-checkbox-modelmanagement"
                          v-model="LLmsModel.IsChainMassage"
                          label="Enable Multi-Turn Input"
                          color="indigo"
                          hide-details
                          density="compact"
                        >
                          <template v-slot:label>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <label text size="x-small" v-bind="props">Enable Multi-Turn Input</label>
                              </template>
                              <span>{{ $t('_InfoMultiTurnInput') }}</span>
                            </v-tooltip>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel>
                <v-expansion-panel>
                  <template v-slot:title>
                    <div class="d-flex align-center panel-header py-2">
                      <v-icon icon="mdi-tune" class="me-3" color="#FF9800"></v-icon>
                      <span class="header">Parameters</span>
                      <!-- <v-icon id="icon-knowledge-modelmanagement" class="ml-auto">{{ panel.includes(0) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon> -->
                    </div>
                  </template>
                  <template v-slot:text>
                    <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          id="temperature-field-modelmanagement"
                          :label="'Temperature*'"
                          v-model="LLmsModel.temperature"
                          density="compact"
                          @keypress="isNumber($event)"
                          variant="outlined"
                          :rules="[validateInput0_1(LLmsModel.temperature)]"
                          required
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoTemperature') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <!-- <v-text-field :label="'top p*'" v-model="LLmsModel.topP" @keypress="isNumber($event)" variant="outlined" density="compact" :disabled="LLmsModel.provider == 'Amazon'"
                              :rules="[validateInput0_1(LLmsModel.topP)]" required> -->
                        <v-text-field
                          id="topP-field-modelmanagement"
                          :label="'Top P'"
                          v-model="LLmsModel.topP"
                          @keypress="isNumber($event)"
                          variant="outlined"
                          density="compact"
                          :disabled="LLmsModel.provider == 'Anthropic'"
                          :rules="[validateInput0_1(LLmsModel.topP)]"
                          required
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoTopP') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <!-- <v-text-field :label="'Frequency penalty'" :disabled="LLmsModel.provider == 'Amazon'" 
                              v-model="LLmsModel.frequencyPenalty" @keypress="isNumber($event)" variant="outlined" density="compact"
                              :rules="[validateInput0_2(LLmsModel.frequencyPenalty)]"> -->
                        <v-text-field
                          id="frequency-penalty-modelmanagement"
                          :label="'Frequency Penalty'"
                          :disabled="LLmsModel.provider == 'Anthropic'"
                          v-model="LLmsModel.frequencyPenalty"
                          @keypress="isNumber($event)"
                          variant="outlined"
                          density="compact"
                          :rules="[validateInput0_2(LLmsModel.frequencyPenalty)]"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoFrequencyPenalty') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <!-- <v-text-field :label="'Presence penalty'" :disabled="LLmsModel.provider == 'Amazon'"
                              v-model="LLmsModel.presencePenalty" @keypress="isNumber($event)" variant="outlined" density="compact"
                              :rules="[validateInput0_2(LLmsModel.presencePenalty)]"> -->
                        <v-text-field
                          id="presence-penalty-modelmanagement"
                          :label="'Presence Penalty'"
                          :disabled="LLmsModel.provider == 'Anthropic'"
                          v-model="LLmsModel.presencePenalty"
                          @keypress="isNumber($event)"
                          variant="outlined"
                          density="compact"
                          :rules="[validateInput0_2(LLmsModel.presencePenalty)]"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoPresencePenalty') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          id="max-tokens-response-modelmanagement"
                          :label="'Max Tokens Response'"
                          clearable
                          variant="outlined"
                          density="compact"
                          @keypress="isNumberpositive($event)"
                          v-model="LLmsModel.maxTokens"
                          :error="error.maxTokens.error"
                          :error-messages="error.maxTokens.message"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoMaxToken') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field id="stop-sequence-modelmanagement" :label="'Stop Sequence'" v-model="LLmsModel.stop" variant="outlined" density="compact" hide-details>
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>
                                {{ $t('_InfoStop') }}
                              </span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel>
                <v-expansion-panel>
                  <template v-slot:title>
                    <div class="d-flex align-center panel-header py-2">
                      <v-icon icon="mdi-radar" class="me-3" color="#4CAF50"></v-icon>
                      <span class="header">Detection</span>
                      <!-- <v-icon id="icon-knowledge-modelmanagement" class="ml-auto">{{ panel.includes(0) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon> -->
                    </div>
                  </template>
                  <template v-slot:text>
                    <v-row style="margin: 5px 0px">
                      <v-col sm="12" md="2"> Intent </v-col>
                      <v-col sm="12" md="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 25px">
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          id="groupintent-autocomplete-modelmanagement"
                          :label="'Group Intent'"
                          :items="listDDIntentGroup"
                          item-title="name"
                          item-value="id"
                          density="compact"
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.IntentGroupID"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoDataIntegration') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row style="margin: 5px 0px" v-if="LLmsModel.typeLLM == 0">
                      <v-col sm="12" md="2"> Guard Rail </v-col>
                      <v-col sm="12" md="10" class="d-flex align-center">
                        <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" v-if="LLmsModel.typeLLM == 0">
                        <v-autocomplete
                          id="guardrailmodel-autocomplete-modelmanagement"
                          :label="'Guard Rail Model'"
                          :items="listGuardRailModel"
                          item-title="name"
                          item-value="modelDisplayID"
                          density="compact"
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.guardRailModelID"
                          hide-details
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoSQLExtractStatement') }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel>
                <v-expansion-panel>
                  <template v-slot:title>
                    <div class="d-flex align-center panel-header py-2">
                      <v-icon icon="mdi-cog" class="me-3" color="#9C27B0"></v-icon>
                      <span class="header">Line Configuration</span>
                      <!-- <v-icon id="icon-knowledge-modelmanagement" class="ml-auto">{{ panel.includes(0) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon> -->
                    </div>
                  </template>
                  <template v-slot:text>
                    <v-row>
                      <v-col cols="12" sm="4" md="3">
                        <v-switch
                          id="loadingbar-enabled-switch-modelmanagement"
                          style="display: inline-block; padding-left: 0.5em; padding-top: 0"
                          v-model="LLmsModel.loadingBarFlag"
                          :label="`Loading bar (${LLmsModel.loadingBarFlag ? 'Enabled' : 'Disabled'})`"
                          color="primary"
                          @click="disabledConfig()"
                          inset
                        ></v-switch>
                      </v-col>
                      <v-col cols="12" sm="4" md="2">
                        <v-autocomplete
                          id="loadingduration-autocomplete-modelmanagement"
                          :label="'Loading duration'"
                          :items="listLoadingDuration"
                          density="compact"
                          clearable
                          variant="outlined"
                          v-model="LLmsModel.loadingBarDuration"
                          style="margin-top: 10px"
                          :disabled="!LLmsModel.loadingBarFlag"
                        >
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-toolbar-title style="font-size: 16px">Monitor</v-toolbar-title>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="3">
                        <v-text-field id="monitor-line-userid-modelmanagement" :label="'Monitor Line UserID'" v-model="LLmsModel.monitorLineUserID" variant="outlined" density="compact">
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoMonitorLINEUserid') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="2">
                        <v-autocomplete
                          id="monitor-line-name-modelmanagement"
                          :label="'Monitor Line Name'"
                          :items="listMonitorLineName"
                          density="compact"
                          clearable
                          variant="outlined"
                          item-title="name"
                          item-value="id"
                          v-model="LLmsModel.monitorSocialID"
                        >
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="4">
                        <v-card class="option-card d-flex flex-column" :class="{ 'option-active': LLmsModel.isShowNameUserMonitor }" flat height="100%" min-height="90px">
                          <div class="d-flex justify-space-between align-start">
                            <div class="option-header">
                              <div class="d-flex align-center">
                                <v-icon color="primary" size="20" class="mr-2">mdi-account-eye-outline</v-icon>
                                <span class="font-weight-medium">Show Line Name</span>
                                <v-tooltip top max-width="300">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon small color="grey lighten-1" v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                  </template>
                                  <span>Display line name in the monitor view</span>
                                </v-tooltip>
                              </div>
                              <div class="grey--text text-caption mt-1">Include line name in monitoring interface</div>
                            </div>
                            <v-switch
                              id="showname-usermonitor-switch"
                              v-model="LLmsModel.isShowNameUserMonitor"
                              color="primary"
                              hide-details
                              dense
                              class="mt-0"
                              inset
                              @click="disabledConfig()"
                            ></v-switch>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-toolbar-title style="font-size: 16px">Forbidden word</v-toolbar-title>
                      </v-col>
                    </v-row>
                    <div class="pr-1" style="border: #dfe0e2 1px solid; background: #fff; margin-top: 10px">
                      <v-row v-for="(item, index) in LLmsModel.forbiddenWord" :key="index" style="margin: 0px">
                        <v-col cols="12" style="padding: 0px">
                          <div style="display: flex; align-items: center">
                            <div style="height: 50px; background: #f8f8f8; padding: 14px 20px 0 20px">
                              {{ index + 1 }}
                            </div>
                            <v-textarea
                              id="forbiddenword-textarea-modelmanagement"
                              variant="solo"
                              style="
                                overflow: hidden;
                                overflow-wrap: break-word;
                                resize: none;
                                height: 50px;
                                width: 98%;
                                border-radius: 0px;
                                font-family:
                                  Fira code,
                                  Fira Mono,
                                  Consolas,
                                  Menlo,
                                  Courier,
                                  monospace;
                                font-size: 14px;
                              "
                              v-model="LLmsModel.forbiddenWord[index]"
                              placeholder="Enter the message"
                              @keypress="isEnter($event, index)"
                              @keyup.delete="CheckDeleteWord(index, LLmsModel.forbiddenWord[index])"
                            ></v-textarea>
                            <v-btn class="forbidden-btn" icon="mdi-attachment" v-show="index + 1 < LLmsModel.forbiddenWord.length" @click="LLmsModel.forbiddenWord.splice(index, 1)">
                              <v-tooltip location="top" :open-delay="500">
                                <template v-slot:activator="{ props }">
                                  <v-icon color="#71717a" style="cursor: pointer" v-bind="props">mdi-delete-forever</v-icon>
                                </template>
                                <span>delete</span>
                              </v-tooltip>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </v-expansion-panel>
                <v-expansion-panel>
                  <template v-slot:title>
                    <div class="d-flex align-center panel-header py-2">
                      <v-icon icon="mdi-message-text" class="me-3" color="#607D8B"></v-icon>
                      <span class="header">System Message</span>
                    </div>
                  </template>
                  <template v-slot:text>
                    <div class="prompt-template-container">
                      <!-- Header with info and action buttons -->
                      <div class="d-flex align-center justify-space-between mb-4">
                        <h3 class="text-subtitle-1 font-weight-medium text-grey-darken-3">
                          <v-icon icon="mdi-pencil-outline" size="small" class="me-2"></v-icon>
                          Configure system message for your AI
                        </h3>
                        <div class="d-flex align-center">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon icon="mdi-information-outline" size="small" color="grey" class="me-3" v-bind="props">mdi-information</v-icon>
                            </template>
                            <span>{{ $t('_InfoAdditionalPromt') }}</span>
                          </v-tooltip>
                          <v-btn
                            id="button-showprompttemplate-modelmanagement"
                            v-if="DDGroupPromptTemplate.length > 0"
                            variant="outlined"
                            color="primary"
                            prepend-icon="mdi-playlist-plus"
                            @click="showPromptTemplate"
                            class="text-none font-weight-medium"
                          >
                            {{ $t('_ShowPromptTemplate') }}
                          </v-btn>
                        </div>
                      </div>

                      <!-- Main editor and templates layout -->
                      <v-row>
                        <!-- Editor area -->
                        <v-col :cols="showPromptTem ? 9 : 12" class="prompt-editor-col">
                          <v-card variant="outlined" class="prompt-editor-card">
                            <v-card-text class="px-2 py-1">
                              <v-textarea
                                id="PromptTemplate"
                                :label="''"
                                variant="plain"
                                counter
                                auto-grow
                                rows="25"
                                v-model="LLmsModel.promptTemplate"
                                :rules="[validatePrompt(LLmsModel.promptTemplate)]"
                                required
                                placeholder="Enter your system message here..."
                                class="prompt-textarea"
                              ></v-textarea>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <!-- Template selector (conditional) -->
                        <v-expand-x-transition>
                          <v-col v-if="showPromptTem" cols="3" class="prompt-templates-col">
                            <v-card class="prompt-templates-card h-100">
                              <v-card-title class="py-3 px-4 d-flex justify-space-between align-center bg-primary text-white">
                                <span class="text-subtitle-2 font-weight-medium">Prompt Templates</span>
                                <v-btn icon="mdi-close" variant="text" color="white" size="small" @click="showPromptTem = false"></v-btn>
                              </v-card-title>

                              <div class="px-3 pt-3">
                                <v-autocomplete
                                  id="groupprompttemplate-autocomplete-modelmanagement"
                                  :label="'Select Template Group'"
                                  :items="DDGroupPromptTemplate"
                                  item-title="name"
                                  item-value="id"
                                  density="compact"
                                  clearable
                                  variant="outlined"
                                  v-model="groupPromptTemplate"
                                  prepend-inner-icon="mdi-folder-outline"
                                  hide-details
                                  class="mb-3"
                                ></v-autocomplete>
                              </div>

                              <v-divider class="mt-2"></v-divider>

                              <v-list class="prompt-template-list" density="compact">
                                <v-list-subheader class="d-flex justify-space-between">
                                  <span>Available Templates</span>
                                  <span class="text-caption text-grey">{{ filteredPromptTemplates.length }} templates</span>
                                </v-list-subheader>

                                <div v-if="filteredPromptTemplates.length === 0" class="pa-4 text-center text-grey-darken-1">
                                  <v-icon icon="mdi-playlist-remove" size="large" class="d-block mx-auto mb-2"></v-icon>
                                  <span>No templates available</span>
                                </div>

                                <template v-else>
                                  <v-list-item v-for="(item, i) in filteredPromptTemplates.slice(0, 10)" :key="i" @click="SetSelectPromptTemplate(item)" :ripple="true" class="template-list-item">
                                    <template v-slot:prepend>
                                      <v-icon icon="mdi-text-box-outline" size="small"></v-icon>
                                    </template>
                                    <template v-slot:title>
                                      <span id="list-nameprompttemplate-modelmanagement" class="text-body-2">{{ item.name }}</span>
                                    </template>
                                    <template v-slot:append>
                                      <v-icon size="small" color="primary">mdi-plus-circle-outline</v-icon>
                                    </template>
                                  </v-list-item>

                                  <div v-if="filteredPromptTemplates.length > 10" class="d-flex justify-center py-2">
                                    <v-btn
                                      id="button-showallprompttemplate-modelmanagement"
                                      variant="text"
                                      color="primary"
                                      size="small"
                                      density="comfortable"
                                      @click="showAll"
                                      prepend-icon="mdi-format-list-bulleted"
                                    >
                                      {{ $t('_ShowAll') }} ({{ filteredPromptTemplates.length }})
                                    </v-btn>
                                  </div>
                                </template>
                              </v-list>
                            </v-card>
                          </v-col>
                        </v-expand-x-transition>
                      </v-row>

                      <!-- Context menu for prompt templates -->
                      <v-menu v-model="showMenu" :activator="{ x, y }" location="bottom">
                        <v-card min-width="250" elevation="3">
                          <v-list density="compact" class="py-0">
                            <v-list-subheader class="d-flex bg-grey-lighten-4 py-2">
                              <v-icon icon="mdi-text-box-plus-outline" class="me-2" size="small"></v-icon>
                              Insert Template
                            </v-list-subheader>
                            <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                            <v-list-item
                              v-for="(item, index) in filteredPromptTemplates"
                              :key="index"
                              @click="
                                SetSelectPromptTemplate(item);
                                showMenu = false;
                              "
                              :value="item.name"
                              class="template-list-item"
                            >
                              <template v-slot:prepend>
                                <v-icon size="small" icon="mdi-text-box-outline"></v-icon>
                              </template>
                              <template v-slot:title>
                                <span>{{ item.name }}</span>
                              </template>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>

                      <!-- Dialog for showing all templates -->
                      <v-dialog v-model="dialogShowAll" max-width="550" scrollable>
                        <v-card>
                          <v-card-title class="bg-primary text-white d-flex align-center">
                            <v-icon icon="mdi-text-box-multiple-outline" class="me-2"></v-icon>
                            Prompt Templates
                          </v-card-title>
                          <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                          <v-card-text style="max-height: 500px" class="pt-4">
                            <v-text-field
                              v-model="templateSearchQuery"
                              label="Search templates"
                              prepend-inner-icon="mdi-magnify"
                              variant="outlined"
                              density="compact"
                              hide-details
                              class="mb-3"
                              clearable
                            ></v-text-field>

                            <v-list density="compact" class="template-list-all pa-0">
                              <v-list-item v-for="(item, i) in searchedTemplates" :key="i" @click="SetSelectPromptTemplate(item)" class="template-list-item" :ripple="true">
                                <template v-slot:prepend>
                                  <v-icon size="small" color="primary" icon="mdi-text-box-outline"></v-icon>
                                </template>
                                <template v-slot:title>
                                  <span id="list-nameprompttemplateall-modelmanagement">{{ item.name }}</span>
                                </template>
                                <template v-slot:subtitle>
                                  <span class="text-caption text-truncate">{{ truncatePrompt(item.prompt) }}</span>
                                </template>
                              </v-list-item>
                            </v-list>
                          </v-card-text>
                          <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                          <v-card-actions class="pa-3 bg-grey-lighten-4">
                            <v-spacer></v-spacer>
                            <v-btn id="button-close-popupshowall-modelmanagement" color="primary" variant="text" @click="dialogShowAll = false">
                              {{ $t('close') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </template>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="page.includes('Playground')" cols="12" justify="end" align="end">
              <v-btn class="text-white mt-3" style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px" @click="closePlayground">CLOSE</v-btn>
              <v-btn class="text-white mt-3" style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 89.863px" @click="savePlayground">SAVE</v-btn>
            </v-col>
            <v-col v-else-if="page == 'Model Creator'" cols="12" justify="end" align="end">
              <!-- <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px"
                    to="/GPTModelManagement">CLOSE</v-btn>
                  <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 89.863px"
                    @click="Save('s')">SAVE</v-btn>
                  <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 120px"
                    @click="Save('s&c')">SAVE & CLOSE</v-btn> -->
            </v-col>
            <v-col v-else cols="12" justify="end" align="end">
              <div v-if="page != 'view model'">
                <v-btn class="text-white mt-3" style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px" to="/GPTModelManagement">CLOSE</v-btn>
                <v-btn v-if="!viewOnly" class="text-white mt-3" style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 89.863px" :disabled="saveLoading" @click="Save('s')"
                  >SAVE</v-btn
                >
                <v-btn
                  v-if="!viewOnly"
                  id="button-saveandclose-modelmanagement"
                  class="text-white mt-3"
                  style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 120px"
                  :disabled="saveLoading"
                  @click="Save('s&c')"
                  >SAVE & CLOSE</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
        <!--showdialog-->
        <v-dialog v-model="dialogShowAll" width="500">
          <v-card max-width="500">
            <v-list density="compact" rounded>
              <v-subheader class="headline" style="color: #1d4f81; font-size: 20px; border-radius: 5px; writing-mode: horizontal-tb">Prompt Template</v-subheader>
              <v-divider :thickness="1" class="border-opacity-100"></v-divider>
              <v-container style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
                <v-list-item v-for="(item, i) in filteredPromptTemplates" :key="i" @click="SetSelectPromptTemplate(item)">
                  <template v-slot:title>
                    <span id="list-nameprompttemplateall-modelmanagement">{{ item.name }}</span>
                  </template>
                </v-list-item>
              </v-container>
            </v-list>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="button-close-popupshowall-modelmanagement" color="blue darken-1" variant="text" @click="dialogShowAll = false">
                {{ $t('close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-container>

    <!-- Version Note Dialog -->
    <v-dialog v-model="versionNoteDialog" max-width="520px" persistent>
      <v-card class="version-note-dialog">
        <v-card-title class="version-note-header pa-4">
          <div class="d-flex align-center">
            <v-icon class="mr-3" color="white" size="28">mdi-content-save-outline</v-icon>
            <div>
              <div class="text-h6 font-weight-bold text-white">
                {{ LLmsModel.modelIDGroup ? 'Update GPT Model' : 'Save GPT Model' }}
              </div>
              <div class="text-caption text-white-50">{{ LLmsModel.modelName || 'Untitled Model' }}</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pa-5">
          <v-alert type="success" variant="tonal" density="compact" class="mb-4">
            <template v-slot:prepend><v-icon>mdi-check-circle</v-icon></template>
            <div class="text-caption"><strong>Ready to save:</strong> {{ LLmsModel.modelIDGroup ? 'Update this model?' : 'Create this model?' }}</div>
          </v-alert>

          <v-textarea
            v-model="versionComment"
            label="Version Note (Optional)"
            placeholder="Describe what changed in this version..."
            variant="outlined"
            density="comfortable"
            rows="3"
            hide-details="auto"
            color="primary"
            maxlength="500"
            counter="500"
          >
            <template v-slot:prepend-inner>
              <v-icon color="grey-darken-1" size="small">mdi-note-text-outline</v-icon>
            </template>
          </v-textarea>
        </v-card-text>

        <v-card-actions class="pa-5 d-flex justify-space-between align-center">
          <v-btn
            variant="outlined"
            color="primary"
            @click="generateVersionNote"
            :disabled="saveLoading || generatingNote || !LLmsModel.modelIDGroup"
            :loading="generatingNote"
            style="border-radius: 8px"
          >
            <v-icon class="mr-2">mdi-auto-fix</v-icon>
            Review
          </v-btn>

          <div class="d-flex gap-2">
            <v-btn
              variant="outlined"
              @click="
                versionNoteDialog = false;
                pendingSaveAction = null;
                generatedHistoryNote = '';
                fieldDiffs = [];
              "
              :disabled="saveLoading"
              style="border-radius: 8px"
              >Cancel</v-btn
            >
            <v-btn color="primary" variant="elevated" :loading="saveLoading" @click="confirmVersionNoteSave()" style="border-radius: 8px">
              <v-icon class="mr-2">{{ LLmsModel.modelIDGroup ? 'mdi-content-save-edit' : 'mdi-content-save' }}</v-icon>
              {{ LLmsModel.modelIDGroup ? 'Update Model' : 'Save Model' }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400" :model-value="saveLoading || dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <v-overlay :value="dialog || saveLoading">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="text-white">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import { kccPickerSource, kccUnavailableReason } from '@/services/kccPickerSource';
export default {
  name: 'ModelManagement',
  mixins: [checkPermissionTwo, LogTrace],
  props: {
    LLmsModel: {
      type: Object,
      default: () => {
        return {
          typeLLM: 0,
          modelId: null,
          modelName: null,
          provider: null,
          model: null,
          APIVersion: null,
          extension: null,
          description: null,
          promptTemplate: '',
          gender: null,
          vectordbName: [],
          groupReplaceID: null,
          productGroupID: [],
          topVDB: null,
          productTopVDB: null,
          productCosine: null,
          internet: null,
          feedback: null,
          historyCount: null,
          historyMinute: null,
          temperature: null,
          topP: null,
          frequencyPenalty: null,
          presencePenalty: null,
          stop: null,
          maxTokens: null,
          isStream: false,
          isBypass: false,
          isFeedback: false,
          isAllowImage: false,
          fileUploadLimit: null,
          versioning: null,
          isPublish: true,
          modelIDGroup: null,
          modelDisplay: null,
          Len_ShortMemory: null,
          IsLongTerm_Memory: false,
          IsChainMassage: false,
          LenChainMassage: null,
          TimeSecondChainMassage: null,
          Cosine: null,
          DataIntegrationID: null,
          SqlModelID: null,
          promptSqlNoData: null,
          guardRailModelID: null,
          IntentGroupID: null,
          maximumChatInput: 200000,
          loadingBarFlag: false,
          loadingBarDuration: 0,
          forbiddenWord: [''],
          monitorLineUserID: null,
          monitorSocialID: null,
          isShowNameUserMonitor: false,
          modelType: null,
          styleImage: null,
          resFormatImage: null,
          quality: null,
          resolution: null,
          enableTime: null,
          timeZone: null,
          jsonRequest: null,
          reasoningEffort: null,
          endPointURL: null,
          apI_Key: null,
          isAllowLLMChange: false,
          flowGroupID: null,
        };
      },
    },
    // DDVector:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDataIntegration:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listSqlExtract:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDGroupReplace:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDPromptTemplate:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDProvider:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDModel:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDIntentGroup:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    GetDDModel: {
      type: String,
      default: null,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
    // editAction: {
    //   type: Boolean,
    //   default: false,
    // },
    modelID: {
      type: String,
      default: null,
    },
    page: {
      type: String,
      default: '-',
    },
    showCompareButton: {
      type: Boolean,
      default: false,
    },
    compareButtonDisabled: {
      type: Boolean,
      default: false,
    },
    compareButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['open-compare', 'open-compare-file'],
  data: () => ({
    id: null,
    activeTab: 0,
    valid: true,
    checkbox1: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: null,
    loading: true,
    switch1: true,
    panel: [5],
    enableFlag: false,
    txtToImgChecker: false,
    imageStyleOptions: [
      { text: 'Natural', value: 'natural' },
      { text: 'Vivid', value: 'vivid' },
    ],
    imageFormatOptions: [
      { text: 'URL', value: 'url' },
      { text: 'Base64 json', value: 'b64_json' },
    ],
    reasonOptions: [
      { text: 'Low', value: 'low' },
      { text: 'Medium', value: 'medium' },
      { text: 'High', value: 'high' },
    ],
    rules: {
      notRequired: () => true,
      required: (value) => !!value || 'Required.',
    },
    GPTModel_isPublish: false,
    DDVector: [],
    // App Knowledge Center (kccPickerSource): kccCenterMode = status.enabled ⇒ DDVector = เอกสารของ Center เท่านั้น ·
    // kccDocsUnavailable = ชื่อ i18n เมื่อดึงรายการไม่ได้ ('' = ไม่มีปัญหา)
    kccCenterMode: false,
    kccDocsUnavailable: '',
    DDGroupReplace: [],
    DDProductGroup: [],
    DDProvider: ['Azure', 'Google'],
    listDataIntegration: [],
    listSqlExtract: [],
    listGuardRailModel: [],
    DDMinute: [
      {
        name: '0',
        value: 0,
      },
      {
        name: '2',
        value: -2,
      },
      {
        name: '10',
        value: -10,
      },
      {
        name: '30',
        value: -30,
      },
      {
        name: '60',
        value: -60,
      },
      {
        name: '720',
        value: -720,
      },
      {
        name: '1440',
        value: -1440,
      },
    ],
    DDModel: [
      {
        provider: 'Azure',
        model: 'gpt-35-turbo-chat',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure',
        model: 'gpt-35-turbo-16k',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure',
        model: 'gpt-4',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-35-postgresql',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-35-16k-postgresql',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-4-postgresql',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-35-Internet',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-35-16k-Internet',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-4-Internet',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-35-turbo-chat',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-35-turbo-16k',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-4',
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    DDGender: [
      {
        id: 'm',
        name: 'Male',
      },
      {
        id: 'f',
        name: 'Female',
      },
    ],
    DDTimeZone: [
      {
        value: 'Asia/Bangkok',
        name: 'Thailand',
      },
      {
        value: 'Asia/Hong_Kong',
        name: 'Hong Kong',
      },
      {
        value: 'Asia/Tokyo',
        name: 'Japan',
      },
      {
        value: 'America/New_York',
        name: 'USA',
      },
      {
        value: 'Europe/London',
        name: 'England',
      },
      {
        value: 'Australia/Sydney',
        name: 'Australia',
      },
    ],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    listDDModel: [],
    listDDIntentGroup: [],
    listDDProvider: [],
    showMenu: false,
    x: 0,
    y: 0,
    DDPromptTemplate: [],
    DDGroupPromptTemplate: [],
    flowDropdown: [],
    PositionPromptTemplate: 0,
    showPromptTem: false,
    dialogShowAll: false,
    groupPromptTemplate: null,
    localEditAction: null,
    listLoadingDuration: [10, 20, 30, 40, 50, 60],
    listMonitorLineName: [],
    showFileUpload: false,
    showReasoningEffort: false,
    saveLoading: false,
    versionNoteDialog: false,
    versionComment: '',
    pendingSaveAction: null,
    pendingSaveModelData: null,
    generatingNote: false,
    generatedHistoryNote: '',
    fieldDiffs: [],
    totalTokens: null,
    error: {
      maxTokens: {
        error: false,
        message: '',
      },
    },
  }),

  watch: {
    // editAction(newVal) {
    //   this.localEditAction = newVal;
    // },
    '$route.params.id': function (newParam) {
      // อัพเดตค่าพารามิเตอร์ด้วยตัวเอง
      this.id = newParam;
    },
    'LLmsModel.provider': function (val) {
      if (val == null) {
        this.LLmsModel.vectordbName = [];
        this.LLmsModel.topVDB = null;
        this.LLmsModel.productGroupID = [];
        this.LLmsModel.productTopVDB = null;
      }
    },
    LLmsModel(val) {
      let self = this;
      self.changeProvider(val.provider);
      self.changeModel(val.model);
    },
  },
  computed: {
    filteredPromptTemplates() {
      if (this.groupPromptTemplate === null) {
        return [];
      }
      return this.DDPromptTemplate.filter((item) => item.groupPromptTemplateID === this.groupPromptTemplate);
    },
    searchedTemplates() {
      if (!this.templateSearchQuery) return this.filteredPromptTemplates;
      const query = this.templateSearchQuery.toLowerCase();
      return this.filteredPromptTemplates.filter((item) => item.name.toLowerCase().includes(query));
    },
  },
  methods: {
    triggerCompareFileUpload() {
      this.$refs.compareFileInput.click();
    },
    handleCompareFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);
          this.$emit('open-compare-file', { name: file.name, data });
        } catch {
          // Let parent handle error if needed
        }
      };
      reader.readAsText(file);
      event.target.value = '';
    },
    getReasoningColor(level) {
      switch (level) {
        case 'low':
          return 'blue-grey';
        case 'medium':
          return 'blue darken-1';
        case 'high':
          return 'indigo darken-2';
        default:
          return 'grey';
      }
    },
    truncatePrompt(text) {
      if (!text) return '';
      return text.length > 60 ? text.substring(0, 60) + '...' : text;
    },
    isEnter: function (evt, index) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 13) {
        evt.preventDefault();
      } else {
        this.CheckNewWord(index);
        return true;
      }
    },
    CheckNewWord(index) {
      let self = this;
      if (self.LLmsModel.forbiddenWord.length == index + 1) {
        self.LLmsModel.forbiddenWord.push('');
      }
      return true;
    },
    CheckDeleteWord(index, value) {
      let self = this;
      if (value == '' && self.LLmsModel.forbiddenWord.length > 1) {
        self.LLmsModel.forbiddenWord.splice(index, 1);
      }
    },
    disabledConfig() {
      return (this.enableFlag = !this.LLmsModel.loadingBarFlag);
    },
    ShowPromptTemplate(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async SetSelectPromptTemplate(val) {
      let self = this;
      var strArray = self.LLmsModel.promptTemplate.split('');
      strArray.splice(self.PositionPromptTemplate, 0, val.prompt);
      self.LLmsModel.promptTemplate = strArray.join('');
    },
    validate() {
      this.$refs.form.validate();
    },
    async Get(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      await self.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            await self.Edit(dataResponse.data);
            await self.changeProvider(self.LLmsModel.provider);
            await self.changeModel(self.LLmsModel.model);
            self.disabledConfig();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    // App Knowledge Center (TASK 2026-10-28 G10 · AC-9 · A4/A19): โหมด Center ⇒ แทน DDVector ด้วย catalog ของ Runtime key
    // (ของในเครื่องซ่อน) · เปิดแต่ไม่มี Runtime key/Center ล้ม ⇒ [] + ข้อความ (ไม่ถอยไปของในเครื่อง) · โหมดปิด (null) ⇒ ไม่แตะ
    async kccApplyVectorList(pending) {
      let list = null;
      try {
        list = await pending;
      } catch (e) {
        list = null;
      }
      this.kccCenterMode = list !== null;
      if (list === null) {
        this.kccDocsUnavailable = '';
        return;
      }
      this.DDVector = list;
      this.kccDocsUnavailable = kccUnavailableReason(list);
    },
    async GetAllDDModelManagement() {
      const id = this.$route.query.id ?? this.LLmsModel.modelId;
      let self = this;
      self.dialog = true;
      // App Knowledge Center: ถามโหมด/รายการของ Center ขนานกับ $call (โหมดปิด ⇒ null — ไม่ยิงอะไรเพิ่มนอกจาก status)
      const kccVectorListPromise = kccPickerSource.vectorList();
      await self.$call.GetAllDDModelManagement(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data.vectorDBName;
            self.listDataIntegration = dataResponse.data.dataIntegration;
            self.DDGroupReplace = dataResponse.data.groupReplace;
            self.DDProductGroup = dataResponse.data.productGroup;
            self.DDProductGroup = dataResponse.data.productGroup;
            self.DDPromptTemplate = dataResponse.data.promptTemplate.listData;
            self.listDDProvider = dataResponse.data.provider;
            // self.listDDProvider.push({ providerName: "Other", id: 0 });
            self.listDDModel = dataResponse.data.modelData;
            self.listDDIntentGroup = dataResponse.data.intentGroup;
            self.DDGroupPromptTemplate = dataResponse.data.groupPromptTemplate;
            self.listMonitorLineName = dataResponse.data.monitorSocialLine;
            self.flowDropdown = dataResponse.data.flowDropdown;
            if (self.modelID) {
              // self.modelID = self.$route.query.id;
              self.listSqlExtract = dataResponse.data.modelPublih.filter((e) => e.idEncrypt != self.modelID && e.typeName == 'Bot');
            } else {
              self.listSqlExtract = dataResponse.data.modelPublih.filter((e) => e.typeName == 'Bot');
            }
            self.listGuardRailModel = dataResponse.data.modelPublih.filter((e) => e.typeName == 'GuardRail');
          } else {
            self.DDVector = [];
            self.listDataIntegration = [];
            self.listSqlExtract = [];
            self.listGuardRailModel = [];
            self.DDGroupReplace = [];
            self.DDProductGroup = [];
            self.DDPromptTemplate = [];
            self.listDDProvider = [];
            self.listDDModel = [];
          }
          // โหมด Center ⇒ DDVector = เอกสารของ Center เท่านั้น (รายการอื่นจาก $call คงเดิม) · โหมดปิด ⇒ ไม่แตะ
          await self.kccApplyVectorList(kccVectorListPromise);
          self.dialog = false;
          if (self.modelID != null) {
            await self.Get(self.modelID);
          }

          if (self.page.includes('Playground')) {
            this.localEditAction = self.page.includes('Edit');
            await self.changeProvider(self.LLmsModel.provider);
            await self.changeModel(self.LLmsModel.model);
          } else if (self.page == 'view model') {
            this.localEditAction = false;
          } else {
            this.localEditAction = false;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    Save(actions) {
      let self = this;
      if (self.validateMaxToken()) {
        return;
      }
      if (self.txtToImgChecker && self.LLmsModel.styleImage == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please select style image and response format image',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (self.LLmsModel.enableTime == true && (self.LLmsModel.timeZone == null || self.LLmsModel.timeZone == '')) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningEnableTime'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (self.LLmsModel.typeLLM == undefined) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTypeLLM'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (self.showReasoningEffort && (self.LLmsModel.reasoningEffort == null || self.LLmsModel.reasoningEffort == '' || self.LLmsModel.reasoningEffort == undefined)) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningReasoningEffort'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      setTimeout(() => {
        self.validate();
      }, 100);
      let modelData = {
        modelId: self.LLmsModel.modelId,
        modelName: self.LLmsModel.modelName,
        provider: self.LLmsModel.provider,
        model: self.LLmsModel.model,
        APIVersion: self.LLmsModel.APIVersion,
        extension: self.LLmsModel.extension,
        description: self.LLmsModel.description,
        promptTemplate: self.LLmsModel.promptTemplate,
        gender: self.LLmsModel.gender,
        vectordbName: self.LLmsModel.vectordbName == null ? [] : self.LLmsModel.vectordbName,
        groupReplaceID: self.LLmsModel.groupReplaceID == null ? [] : self.LLmsModel.groupReplaceID,
        productGroupID: self.LLmsModel.productGroupID == null ? [] : self.LLmsModel.productGroupID,
        topVDB: self.LLmsModel.topVDB !== '' ? self.LLmsModel.topVDB : null,
        productTopVDB: self.LLmsModel.productTopVDB !== '' ? self.LLmsModel.productTopVDB : null,
        productCosine: self.LLmsModel.productCosine !== '' ? self.LLmsModel.productCosine : null,
        internet: self.LLmsModel.internet,
        feedback: self.LLmsModel.feedback,
        historyCount: self.LLmsModel.historyCount,
        historyMinute: self.LLmsModel.historyMinute > 0 ? -self.LLmsModel.historyMinute : self.LLmsModel.historyMinute,
        temperature: self.LLmsModel.temperature !== '' ? self.LLmsModel.temperature : null,
        topP: self.LLmsModel.topP !== '' ? self.LLmsModel.topP : null,
        frequencyPenalty: self.LLmsModel.frequencyPenalty !== '' ? self.LLmsModel.frequencyPenalty : null,
        presencePenalty: self.LLmsModel.presencePenalty !== '' ? self.LLmsModel.presencePenalty : null,
        stop: self.LLmsModel.stop !== '' ? self.LLmsModel.stop : null,
        maxTokens: self.LLmsModel.maxTokens == null || self.LLmsModel.maxTokens == '' ? self.totalTokens : self.LLmsModel.maxTokens,
        isStream: self.LLmsModel.isStream,
        // isBypass : self.LLmsModel.IsBypass,
        isFeedback: self.LLmsModel.isFeedback,
        isAllowImage: self.LLmsModel.isAllowImage,
        fileUploadLimit: self.LLmsModel.fileUploadLimit == null ? self.LLmsModel.fileUploadLimit : parseInt(self.LLmsModel.fileUploadLimit),
        versioning: self.LLmsModel.versioning,
        isPublish: self.LLmsModel.isPublish,
        modelIDGroup: self.LLmsModel.modelIDGroup,
        modelDisplay: self.LLmsModel.modelDisplay,
        Len_ShortMemory: self.LLmsModel.Len_ShortMemory ?? 200,
        IsLongTerm_Memory: self.LLmsModel.provider == 'Google' ? false : (self.LLmsModel.IsLongTerm_Memory ?? false),
        IsChainMassage: self.LLmsModel.IsChainMassage ?? false,
        LenChainMassage: self.LLmsModel.LenChainMassage,
        TimeSecondChainMassage: self.LLmsModel.TimeSecondChainMassage,
        Cosine: self.LLmsModel.Cosine,
        DataIntegrationID: self.LLmsModel.DataIntegrationID,
        SqlModelID: self.LLmsModel.SqlModelID,
        promptSqlNoData: self.LLmsModel.promptSqlNoData,
        IntentGroupID: self.LLmsModel.IntentGroupID,
        typingSpeed: parseInt(self.LLmsModel.typingSpeed),
        maximumChatInput: self.LLmsModel.maximumChatInput == null ? 200000 : parseInt(self.LLmsModel.maximumChatInput),
        loadingBarFlag: self.LLmsModel.loadingBarFlag,
        loadingBarDuration: self.LLmsModel.loadingBarDuration,
        forbiddenWord: self.forbiddenWordSaveHandle(self.LLmsModel.forbiddenWord),
        monitorLineUserID: self.LLmsModel.monitorLineUserID,
        isShowNameUserMonitor: self.LLmsModel.isShowNameUserMonitor,
        monitorSocialID: self.LLmsModel.monitorSocialID,
        styleImage: self.txtToImgChecker ? self.LLmsModel.styleImage : null,
        resFormatImage: self.txtToImgChecker ? 'url' : null,
        modelType: self.LLmsModel.modelType,
        quality: self.txtToImgChecker ? self.LLmsModel.quality : null,
        resolution: self.txtToImgChecker ? self.LLmsModel.resolution : null,
        JsonRequest: self.LLmsModel.jsonRequest,
        typeLLM: self.LLmsModel.typeLLM == 1 ? 'GuardRail' : 'Bot',
        guardRailModelID: self.LLmsModel.typeLLM == 0 ? self.LLmsModel.guardRailModelID : null,
        timeZone: self.LLmsModel.enableTime ? self.LLmsModel.timeZone : null,
        reasoningEffort: self.showReasoningEffort ? self.LLmsModel.reasoningEffort : null,
        endPointURL: self.LLmsModel.endPointURL != '' && self.LLmsModel.endPointURL != null ? self.LLmsModel.endPointURL : null,
        apI_Key: self.LLmsModel.apI_Key != '' && self.LLmsModel.apI_Key != null ? self.LLmsModel.apI_Key : null,
        isAllowLLMChange: self.LLmsModel.isAllowLLMChange,
        flowGroupID: self.LLmsModel.flowGroupID,
        versionComment: '',
      };

      if (self.LLmsModel.modelName == null || self.LLmsModel.modelName == '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningModelName'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.provider) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningProvider'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.model) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningModel'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.isPublish == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningPublish'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (this.LLmsModel.IsChainMassage == true) {
        if (this.LLmsModel.LenChainMassage == null || this.LLmsModel.LenChainMassage == '' || this.LLmsModel.TimeSecondChainMassage == null || this.LLmsModel.TimeSecondChainMassage == '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningChainMassage'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
      } else if (self.LLmsModel.temperature == null || self.LLmsModel.temperature < 0 || self.LLmsModel.temperature > 1 || self.LLmsModel.temperature === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTemperature'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.topP == null || self.LLmsModel.topP < 0 || self.LLmsModel.topP > 1 || self.LLmsModel.topP === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopP'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.maximumChatInput == null || self.LLmsModel.maximumChatInput < 0 || self.LLmsModel.maximumChatInput === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningmaximumChatInput'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.topVDB == null && self.LLmsModel.vectordbName.length > 0) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.productTopVDB == null && self.LLmsModel.productGroupID.length > 0) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (
        (self.LLmsModel.APIVersion == '' || self.LLmsModel.APIVersion == null) &&
        self.LLmsModel.provider != 'Google' &&
        self.LLmsModel.provider != 'OpenAI' &&
        self.LLmsModel.provider != 'Other'
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningAPIVersion'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (typeof self.validatePrompt(self.LLmsModel.promptTemplate) == 'string') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please Enter Correct Format!',
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      try {
        self.saveLoading = true;
        // console.log("Save actions:", self.saveLoading);
        self.LLmsModel.frequencyPenalty = self.LLmsModel.frequencyPenalty != '' ? self.LLmsModel.frequencyPenalty : null;
        self.LLmsModel.presencePenalty = self.LLmsModel.presencePenalty != '' ? self.LLmsModel.presencePenalty : null;
        self.LLmsModel.topVDB = self.LLmsModel.topVDB != '' ? self.LLmsModel.topVDB : null;
        self.LLmsModel.productTopVDB = self.LLmsModel.productTopVDB != '' ? self.LLmsModel.productTopVDB : null;
        self.LLmsModel.IsLongTerm_Memory = self.LLmsModel.provider == 'Google' ? false : (self.LLmsModel.IsLongTerm_Memory ?? false);
        self.LLmsModel.typingSpeed = parseInt(self.LLmsModel.typingSpeed);
        self.LLmsModel.maximumChatInput = parseInt(self.LLmsModel.maximumChatInput);
        // Store data and open version note popup
        self.pendingSaveAction = actions;
        self.pendingSaveModelData = modelData;
        self.versionComment = '';
        self.saveLoading = false;
        self.dialog = false;
        self.versionNoteDialog = true;
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    async generateVersionNote() {
      let self = this;

      // Only allow for existing models (updates)
      if (!self.LLmsModel.modelIDGroup) {
        self.$swal.fire({
          icon: 'info',
          title: 'Not Available',
          text: 'Version note generation is only available when updating existing models.',
          showConfirmButton: true,
          confirmButtonColor: '#1976d2',
        });
        return;
      }

      self.generatingNote = true;

      try {
        // Prepare the request data based on pendingSaveModelData
        const modelData = self.pendingSaveModelData;

        const request = {
          modelName: modelData.modelName,
          provider: modelData.provider,
          model: modelData.model,
          APIVersion: modelData.APIVersion,
          extension: modelData.extension,
          description: modelData.description,
          promptTemplate: modelData.promptTemplate,
          gender: modelData.gender,
          vectordbName: modelData.vectordbName,
          groupReplaceID: modelData.groupReplaceID,
          productGroupID: modelData.productGroupID,
          topVDB: modelData.topVDB,
          ProductTopVDB: modelData.productTopVDB,
          ProductCosine: modelData.productCosine,
          internet: modelData.internet,
          feedback: modelData.feedback,
          historyCount: modelData.historyCount,
          historyMinute: modelData.historyMinute,
          temperature: modelData.temperature,
          topP: modelData.topP,
          frequencyPenalty: modelData.frequencyPenalty,
          presencePenalty: modelData.presencePenalty,
          stop: modelData.stop,
          maxTokens: modelData.maxTokens,
          isStream: modelData.isStream,
          ModelIDGroup: modelData.modelIDGroup,
          versioning: modelData.versioning,
          isPublish: modelData.isPublish,
          modelDisplay: modelData.modelDisplay,
          isBypass: modelData.isBypass,
          IsChainMassage: modelData.IsChainMassage,
          LenChainMassage: modelData.LenChainMassage,
          TimeSecondChainMassage: modelData.TimeSecondChainMassage,
          Len_ShortMemory: modelData.Len_ShortMemory,
          IsLongTerm_Memory: modelData.IsLongTerm_Memory,
          Cosine: modelData.Cosine,
          DataIntegrationID: modelData.DataIntegrationID,
          SqlModelID: modelData.SqlModelID,
          PromptSqlNoData: modelData.promptSqlNoData,
          IntentGroupID: modelData.IntentGroupID,
          IsFeedback: modelData.isFeedback,
          IsAllowImage: modelData.isAllowImage,
          fileUploadLimit: modelData.fileUploadLimit,
          TypingSpeed: modelData.typingSpeed,
          MaximumChatInput: modelData.maximumChatInput,
          LoadingBarFlag: modelData.loadingBarFlag,
          LoadingBarDuration: modelData.loadingBarDuration,
          ForbiddenWord: modelData.forbiddenWord,
          IsShowNameUserMonitor: modelData.isShowNameUserMonitor,
          MonitorLineUserID: modelData.monitorLineUserID,
          MonitorSocialID: modelData.monitorSocialID,
          GuardRailModelID: modelData.guardRailModelID,
          TypeLLM: modelData.typeLLM,
          modelType: modelData.modelType,
          quality: modelData.quality,
          resolution: modelData.resolution,
          styleImage: modelData.styleImage,
          resFormatImage: modelData.resFormatImage,
          JsonRequest: modelData.JsonRequest,
          TimeZone: modelData.timeZone,
          ReasoningEffort: modelData.reasoningEffort,
          EndPointURL: modelData.endPointURL,
          API_Key: modelData.apI_Key,
          IsAllowLLMChange: modelData.isAllowLLMChange,
          FlowGroupID: modelData.flowGroupID,
        };

        await self.$call.SummarizeGPTModelChanges(
          request,
          modelData.modelId,
          (dataResponse) => {
            if (dataResponse.status === 0) {
              self.generatedHistoryNote = dataResponse.data.historyNote || '';
              self.fieldDiffs = dataResponse.data.diff || [];

              if (self.generatedHistoryNote) {
                self.versionComment = self.generatedHistoryNote;
              }

              self.$swal.fire({
                icon: 'success',
                title: 'Note Generated',
                text: 'Version note has been generated successfully!',
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              self.$swal.fire({
                icon: 'error',
                title: 'Generation Failed',
                text: dataResponse.message || 'Failed to generate version note.',
                showConfirmButton: true,
                confirmButtonColor: '#d33',
              });
            }
            self.generatingNote = false;
          },
          (errorResource) => {
            self.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'An error occurred while generating the version note.',
              showConfirmButton: true,
              confirmButtonColor: '#d33',
            });
            self.generatingNote = false;
          }
        );
      } catch (error) {
        self.generatingNote = false;
        self.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An unexpected error occurred.',
          showConfirmButton: true,
          confirmButtonColor: '#d33',
        });
      }
    },
    confirmVersionNoteSave() {
      let self = this;
      self.versionNoteDialog = false;
      self.dialog = true;
      self.saveLoading = true;
      const actions = self.pendingSaveAction;
      const modelData = { ...self.pendingSaveModelData, versionComment: self.versionComment };
      self.$call.AddGPTModel(
        modelData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
              allowOutsideClick: true,
              allowEscapeKey: true,
              allowEnterKey: true,
              backdrop: false,
            });

            if (actions == 's&c') self.$router.push('/GPTModelManagement');
            else {
              self.$router
                .push({
                  name: 'GPTModelDetail',
                  query: {
                    id: dataResponse.data,
                  },
                })
                .then(() => {
                  self.Get(dataResponse.data);
                });
            }
          }
          if (dataResponse.status == 1 && dataResponse.data.is_exist) {
            self.$swal.fire({
              icon: 'error',
              title: 'Model ID is exist',
              showConfirmButton: false,
              timer: 1800,
            });
          }
          self.saveLoading = false;
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },
    async Edit(item) {
      let self = this;
      if (self.page !== 'Model Creator') {
        self.localEditAction = true;
      } else {
        self.localEditAction = null;
      }
      self.GPTModel_isPublish = item.isPublish;
      self.LLmsModel.modelId = item.modelID;
      self.LLmsModel.modelName = item.modelName;
      self.LLmsModel.provider = item.provider;
      self.LLmsModel.model = item.model;
      self.LLmsModel.APIVersion = item.apiVersion;
      self.LLmsModel.extension = item.extension;
      self.LLmsModel.description = item.description;
      self.LLmsModel.promptTemplate = item.promptTemplate;
      self.LLmsModel.gender = item.gender;
      self.LLmsModel.vectordbName = item.vectordbName;
      self.LLmsModel.groupReplaceID = item.groupReplaceID;
      self.LLmsModel.productGroupID = item.productGroupID ?? [];
      self.LLmsModel.topVDB = item.topVDB;
      self.LLmsModel.productTopVDB = item.productTopVDB;
      self.LLmsModel.productCosine = item.productCosine;
      self.LLmsModel.internet = item.internet;
      self.LLmsModel.feedback = item.feedback;
      self.LLmsModel.historyCount = item.historyCount;
      self.LLmsModel.historyMinute = item.historyMinute < 0 ? Math.abs(item.historyMinute) : item.historyMinute;
      self.LLmsModel.temperature = item.temperature;
      self.LLmsModel.topP = item.top_p;
      self.LLmsModel.frequencyPenalty = item.frequency_penalty;
      self.LLmsModel.presencePenalty = item.presence_penalty;
      self.LLmsModel.stop = item.stop;
      self.LLmsModel.maxTokens = item.max_tokens;
      self.LLmsModel.isStream = item.isStream;
      self.LLmsModel.isBypass = item.isBypass;
      self.LLmsModel.isFeedback = item.isFeedback;
      self.LLmsModel.isAllowImage = item.isAllowImage;
      self.LLmsModel.fileUploadLimit = item.fileUploadLimit == null ? item.fileUploadLimit : parseInt(item.fileUploadLimit);
      self.LLmsModel.versioning = item.versioning;
      self.LLmsModel.isPublish = self.page == 'view model' ? (item.isPublish == null ? false : item.isPublish) : item.isPublish;
      self.LLmsModel.modelIDGroup = item.modelIDGroup;
      self.LLmsModel.modelDisplay = item.modelDisplay;
      self.LLmsModel.Len_ShortMemory = item.len_ShortMemory ?? 200;
      self.LLmsModel.IsLongTerm_Memory = self.LLmsModel.provider == 'Google' ? false : (item.isLongTerm_Memory ?? false);
      self.LLmsModel.IsChainMassage = item.isChainMassage ?? false;
      self.LLmsModel.LenChainMassage = item.lenChainMassage;
      self.LLmsModel.TimeSecondChainMassage = item.timeSecondChainMassage;
      self.LLmsModel.Cosine = item.cosine;
      self.LLmsModel.DataIntegrationID = item.dataIntegrationID;
      self.LLmsModel.SqlModelID = item.sqlModelID;
      self.LLmsModel.promptSqlNoData = item.promptSqlNoData;
      self.LLmsModel.IntentGroupID = item.intentGroupID;
      self.LLmsModel.typingSpeed = parseInt(item.typingSpeed);
      self.LLmsModel.maximumChatInput = item.maximumChatInput == null ? 200000 : parseInt(item.maximumChatInput);
      self.LLmsModel.loadingBarFlag = item.loadingBarFlag;
      self.LLmsModel.loadingBarDuration = item.loadingBarDuration;
      self.LLmsModel.forbiddenWord = self.forbiddenWordHandle(item.forbiddenWord) ?? [''];
      self.LLmsModel.monitorLineUserID = item.monitorLineUserID;
      self.LLmsModel.isShowNameUserMonitor = item.isShowNameUserMonitor;
      self.LLmsModel.monitorSocialID = item.monitorSocialID;
      self.LLmsModel.typeLLM = item.typeLLM == 'GuardRail' ? 1 : 0;
      self.LLmsModel.guardRailModelID = item.guardRailModelID;
      self.LLmsModel.modelType = item.modelType;
      self.LLmsModel.styleImage = item.styleImage;
      self.LLmsModel.resFormatImage = 'url';
      self.LLmsModel.quality = item.quality;
      self.LLmsModel.resolution = item.resolution;
      self.LLmsModel.jsonRequest = item.jsonRequest;
      self.LLmsModel.enableTime = item.timeZone ? true : false;
      self.LLmsModel.timeZone = item.timeZone;
      self.LLmsModel.reasoningEffort = item.reasoningEffort;
      self.LLmsModel.endPointURL = item.endPointURL;
      self.LLmsModel.apI_Key = item.apI_Key;
      self.EditdialogUser = true;
      self.LLmsModel.isAllowLLMChange = item.isAllowLLMChange;
      self.LLmsModel.flowGroupID = item.flowGroupID;
      // let templistDDVector = self.DDVector.map((item) => item.name);
      // self.LLmsModel.vectordbName = self.LLmsModel.vectordbName.filter((item) =>
      //   templistDDVector.includes(item)
      // );
    },
    savePlayground() {
      let self = this;
      self.$emit('is-event', 'SaveEdit');
    },
    closePlayground() {
      let self = this;
      self.$emit('is-event', 'Close');
    },
    checkValidate() {
      if (this.LLmsModel.vectordbName != null && this.LLmsModel.vectordbName != '') {
        if (this.LLmsModel.topVDB == '' || this.LLmsModel.topVDB == null) {
          return 'Required.';
        } else if (parseInt(this.LLmsModel.topVDB) == 0) {
          return 'Required.';
        }
      }
      if (this.LLmsModel.IsChainMassage == true) {
        if (this.LLmsModel.LenChainMassage == null || this.LLmsModel.LenChainMassage == '' || this.LLmsModel.TimeSecondChainMassage == null || this.LLmsModel.TimeSecondChainMassage == '') {
          return 'Required.';
        }
      }
      return true;
    },
    checkProductValidate() {
      if (this.LLmsModel.productGroupID != null && this.LLmsModel.productGroupID != '') {
        if (this.LLmsModel.productTopVDB == '' || this.LLmsModel.productTopVDB == null) {
          return 'Required.';
        } else if (parseInt(this.LLmsModel.productTopVDB) == 0) {
          return 'Required.';
        }
      }
      return true;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    maxNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;

      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionStart);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > 6 || // Check if the length exceeds 6 characters
        parseInt(newValue) > 200000
      ) {
        // Check if the number exceeds 200000
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;
      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionStart);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > 5 || // Check if the length exceeds 4 characters
        parseInt(newValue) > 20000 // Check if the number exceeds 2048
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return inputValue.length <= this.maxLengthChar || 'กรุณากรอกข้อมูลตัวอักษรไม่เกิน ' + this.convertNumberToStringFormat(this.maxLengthChar);
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return 'Required.';
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateMaxToken() {
      this.error.maxTokens.error = false;
      this.error.maxTokens.message = '';
      if (this.LLmsModel.maxTokens > this.totalTokens && this.totalTokens != null) {
        this.error.maxTokens.error = true;
        this.error.maxTokens.message = 'Max tokens cannot exceed the total tokens limit ' + this.totalTokens;
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.error.maxTokens.message,
          showConfirmButton: false,
          timer: 3000,
          backdrop: false,
        });
        return true;
      }
      return false;
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    customFilter(fn, listData) {
      const f = [];
      for (let i = 0; i < listData.length; i++) {
        if (fn(listData[i])) {
          f.push(listData[i]);
        }
      }
      return f;
    },
    async changeProvider(value) {
      let self = this;
      if (value == null || value == '') {
        self.DDModelShow = [];
        return 'Required.';
      } else {
        if (value == 'Google' || value == 'Anthropic' || value == 'Azure') {
          self.DDModelShow = self.listDDModel.filter((e) => e.provider == value);
        } else {
          self.DDModelShow = self.listDDModel.filter((e) => e.provider == value);
        }
        // self.LLmsModel.typeLLM = 0;
      }
    },
    clearLLM() {
      this.LLmsModel.model = null;
    },
    async changeModel(value) {
      let self = this;
      if (value == null || value == '' || value.split('')[0] == '|') {
        self.maxLengthChar = 0;
        self.LLmsModel.model = null;
        if (value.split('')[0] == '|') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: 'Please select model',
            showConfirmButton: false,
            timer: 3000,
          });
        }
        return 'required.';
      } else {
        let ddm = self.listDDModel.find((e) => e.modelName == value);
        self.totalTokens = ddm.maxToken;
        self.txtToImgChecker = ddm.modelType == 'text_to_image';
        if (ddm) {
          if (value == 'gpt-35-turbo') {
            self.maxLengthChar = 4000;
          } else if (value == 'gpt-35-turbo-16k') {
            self.maxLengthChar = 8000;
          } else if (value == 'gpt-4') {
            self.maxLengthChar = 6000;
          } else {
            self.maxLengthChar = null;
          }
          if (this.txtToImgChecker) {
            // self.LLmsModel.styleImage = ddm.styleImage;
            // self.LLmsModel.resFormatImage = ddm.resFormatImage;
            self.LLmsModel.quality = ddm.quality;
            self.LLmsModel.resolution = ddm.resolution;
            self.LLmsModel.resFormatImage = 'url';
          } else {
            self.LLmsModel.styleImage = null;
            self.LLmsModel.resFormatImage = null;
            self.LLmsModel.quality = null;
            self.LLmsModel.resolution = null;
          }
          self.LLmsModel.APIVersion = ddm.apiVersion;
          self.LLmsModel.modelType = ddm.modelType;
          self.LLmsModel.jsonRequest = ddm.jsonRequest;
          self.showReasoningEffort = ddm.useReasoningEffort;
          self.LLmsModel.endPointURL = ddm.endPointURL;
          self.LLmsModel.apI_Key = ddm.apI_Key;
          // self.maxLengthChar = self.DDModel.find((e) => e.model == value).maxPrompt;
        } else {
          self.maxLengthChar = null;
        }

        if (ddm.useUploadFile) {
          self.showFileUpload = ddm.useUploadFile;
        } else {
          self.showFileUpload = false;
          self.LLmsModel.isAllowImage = false;
          self.LLmsModel.fileUploadLimit = null;
        }
      }
    },
    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showPromptTemplate() {
      let self = this;
      if (self.DDGroupPromptTemplate.length > 0) {
        self.showPromptTem = !self.showPromptTem;
      } else {
        self.showPromptTem = false;
      }
    },
    showAll() {
      let self = this;
      self.dialogShowAll = true;
    },
    forbiddenWordHandle(forbiddenWord) {
      if (forbiddenWord != null) {
        const parsedData = [...JSON.parse(forbiddenWord), ''];
        return parsedData;
      }
    },
    forbiddenWordSaveHandle(inputList) {
      if (inputList[0].trim() === '') {
        return null;
      } else {
        inputList = inputList.filter((element) => element.trim() !== '');
        inputList = JSON.stringify(inputList);
      }
      return inputList;
    },
  },
  async mounted() {
    let self = this;
    await self.GetAllDDModelManagement();
    if (!this.LLmsModel.reasoningEffort && this.reasonOptions.length > 0) {
      this.LLmsModel.reasoningEffort = this.reasonOptions[0].value;
    }
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.model-header-row {
  margin-bottom: 0;
}

.model-header-compare-btn {
  min-width: 120px;
  flex-shrink: 0;
}

.model-header-compare-group {
  flex-shrink: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}

.v-text-field :deep(label) {
  font-size: 0.9375rem;
}

.v-expansion-panel-header {
  padding: 0;
  background-color: transparent !important;
}

:deep(.expan-Pannel) .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
  background-color: transparent !important;
}

.forbidden-btn {
  opacity: 0;
}

.forbidden-btn:hover {
  opacity: 100%;
}

.deep-purple.accent-4 {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
}

.image-settings-container {
  border-radius: 4px;
  padding: 16px;
}

.info-icon {
  position: absolute;
  right: -6px;
  top: 0;
}

.image-select {
  width: auto;
}

.info-icon:hover {
  color: #1976d2;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
}

.v-col {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.v-card {
  /* background-color: transparent !important; */
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none;
}

.v-tab {
  text-transform: none;
  font-weight: 500;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details {
  margin-bottom: 0;
}

.model-type-toggle {
  width: 100% !important;
  border-radius: 6px;
  border: 0.5px solid gray;
}

.model-type-btn {
  flex: 1;
  height: 36px !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  min-width: 120px !important;
}

.model-type-btn:first-child {
  border-radius: 4px 0 0 4px;
}

.model-type-btn:last-child {
  border-radius: 0 4px 4px 0;
}

.model-type-card {
  border-radius: 12px;
  border: none !important;
  transition: background 1s ease;
}

/* Bot button styles */
.v-btn-toggle .v-btn[value='0'].v-btn--active {
  background-color: #1976d2 !important;
  color: white !important;
}

/* Guard Rail button styles */
.v-btn-toggle .v-btn[value='1'].v-btn--active {
  background-color: #4caf50 !important;
  color: white !important;
}

/* Make expansion panel background transparent */
:deep(.v-expansion-panels) {
  background-color: transparent !important;
}

/* Make individual expansion panel background transparent */
:deep(.v-expansion-panel) {
  background-color: transparent !important;
}

/* Make expansion panel content background transparent */
:deep(.v-expansion-panel-content) {
  background-color: transparent !important;
}

/* Make expansion panel header background transparent */
:deep(.v-expansion-panel-header) {
  background-color: transparent !important;
}

/* Optional: Remove box-shadow if present */
:deep(.v-expansion-panels) {
  box-shadow: none !important;
}

:deep(.v-expansion-panel)::before {
  box-shadow: none !important;
}

.model-chip {
  padding: 0 50px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.5s ease;
}

.model-chip:hover {
  opacity: 1;
}

.model-id {
  color: black;
  margin-left: 4px;
  font-weight: 500;
}

/* Optional: Add a subtle animation when the chip appears */
.model-chip {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.position-relative {
  position: relative;
}

.version-badge {
  z-index: 1;
}

.version-text {
  margin-left: -4px;
  font-size: 11px;
  font-weight: 500;
  color: #616161;
  letter-spacing: 0.4px;
}
.modern-panels {
  background-color: transparent;
}

.modern-panels :deep(.v-expansion-panel) {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.modern-panels :deep(.v-expansion-panel--active) {
  border-color: rgba(25, 118, 210, 0.5);
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.modern-panels :deep(.v-expansion-panel-title) {
  min-height: 60px;
  border-radius: 8px;
  transition: all 0.3s ease;
}
.modern-panels :deep(.v-expansion-panel-text) {
  padding-top: 20px;
}

.modern-panels :deep(.v-expansion-panel-title--active) {
  background-color: rgba(25, 118, 210, 0.04);
}

.modern-panels :deep(.v-expansion-panel-title:hover) {
  background-color: rgba(0, 0, 0, 0.03);
}

.panel-header .header {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  color: rgba(0, 0, 0, 0.87);
}

.modern-panels :deep(.v-expansion-panel-title--active) .header {
  color: #1976d2;
}

.panel-content {
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: rgba(250, 250, 252, 0.7);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

/* อนิเมชัน */
.transition-swing {
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.prompt-template-container {
  padding: 0.5rem 0;
}

.prompt-editor-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  transition: all 0.2s ease;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5);
  box-shadow: 0 1px 3px rgba(227, 6, 6, 0.05);
}

.prompt-textarea {
  font-family: 'Roboto Mono', monospace;
  line-height: 1.5;
  border: none !important;
  box-shadow: none !important;
  padding: 12px !important;
  font-size: 14px;
  min-height: 300px !important;
}

.prompt-editor-card {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
  overflow: hidden;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5) !important;
}

.prompt-templates-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
}

.template-list-item {
  border-radius: 4px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.template-list-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.prompt-template-list {
  max-height: 500px;
  overflow-y: auto;
}

.template-list-all {
  max-height: 400px;
  overflow-y: auto;
}
.v-divider {
  border-color: rgba(0, 0, 0, 0.753) !important;
}
.v-card {
  transition: all 0.2s ease;
}

.rounded-lg {
  border-radius: 8px !important;
}

.v-card__title {
  font-size: 1rem !important;
  padding: 12px 16px !important;
}

.v-card__text {
  padding: 12px 16px !important;
}

.h-100 {
  height: 100%;
}

/* Fix position of tooltips */
:deep(.v-tooltip__content) {
  background-color: rgba(33, 33, 33, 0.95);
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 5px 10px;
}

.options-section {
  padding: 16px 20px;
}
.option-card {
  padding: 16px;
  border-radius: 10px !important;
  background-color: #f8f9fa;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
}

.option-card:hover {
  border-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08) !important;
}

.option-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 0;
  background-color: var(--v-primary-base);
  transition: height 0.2s ease;
}

.option-active::before {
  height: 100%;
}

.option-active {
  background-color: rgba(25, 118, 210, 0.05);
}

.on-hover {
  border-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08) !important;
}

.option-header {
  max-width: calc(100% - 50px);
}

.reasoning-select {
  background-color: transparent !important;
}

.reasoning-select :deep(.v-input__slot) {
  background-color: white !important;
  transition: all 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.reasoning-select :deep(.v-input__slot:hover) {
  border-color: rgba(25, 118, 210, 0.5) !important;
}

/* Card title styling */
.v-card__title.subtitle-1 {
  font-size: 16px !important;
  padding: 14px 20px !important;
  background-color: transparent;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.additional-content {
  padding-bottom: 8px;
  min-height: 58px;
}

.upload-limit-field,
.timezone-field {
  min-height: 58px;
}

.status-switch-container {
  border-radius: 8px;
  background-color: #f5f5f5;
  transition: all 0.3s ease;
}

.status-switch {
  transform: scale(1.2);
}

.status-label {
  min-width: 150px;
}
.status-container {
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-toggle {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.toggle-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  min-width: 90px;
}

.active-btn.draft-btn {
  background-color: rgba(255, 152, 0, 0.1) !important;
  color: #ff9800 !important;
  font-weight: 500;
}

.active-btn.publish-btn {
  background-color: rgba(76, 175, 80, 0.1) !important;
  color: #4caf50 !important;
  font-weight: 500;
}

.enhanced-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.enhanced-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.enhanced-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Selection Display */
.timezone-selection {
  width: 100%;
  padding: 2px 0;
}

.timezone-code {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Dropdown Items */
.timezone-item {
  padding: 12px 16px !important;
  border-radius: 6px;
  margin: 2px 8px;
  transition: all 0.2s ease;
}

.timezone-item:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
  transform: translateX(2px);
}

.timezone-item-content {
  width: 100%;
}

.timezone-country {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.2;
}

.timezone-details {
  gap: 8px;
}

/* Avatar styling */
.timezone-item :deep(.v-avatar) {
  margin-right: 12px;
}

/* Dropdown styling */
.enhanced-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.enhanced-select :deep(.v-list) {
  padding: 8px 0 !important;
  background-color: white;
}

/* Icon animations */
.timezone-item :deep(.v-icon) {
  transition: all 0.2s ease;
}

.timezone-item:hover :deep(.v-icon) {
  transform: scale(1.1);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .timezone-selection {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .timezone-code {
    margin-left: 0 !important;
    margin-top: 4px !important;
  }
}

.reasoning-chip {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  min-width: 120px;
  height: 28px !important;
}

.reasoning-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  text-align: center !important;
  font-weight: 500;
}

.reasoning-chip :deep(.v-chip__underlay) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* สำหรับ Vuetify 3 */
.reasoning-chip :deep(.v-chip__content) {
  padding: 0 8px !important;
  line-height: 2 !important;
}
/* Image Generation Settings Styling */
.image-settings-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.image-header {
  background: linear-gradient(135deg, rgba(215, 235, 255, 0.185) 10%, rgba(25, 118, 210, 0.226) 100%);
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.setting-group {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  height: 100%;
}

.setting-group:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
}

/* Enhanced Select Styling */
.style-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
  background: white;
}

.style-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
  border-color: rgba(11, 133, 255, 0.829) !important;
}

.style-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
  border-color: rgba(25, 118, 210, 0.8) !important;
}

/* Style Items */
.style-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
}

.style-item:hover {
  background: linear-gradient(135deg, rgba(220, 237, 255, 0.767) 0%, rgba(138, 197, 255, 0.568) 100%);
  transform: translateX(3px);
}

/* Quality and Resolution Fields */
.quality-field :deep(.v-field),
.resolution-field :deep(.v-field) {
  border-radius: 8px !important;
  background: rgba(245, 245, 245, 0.8) !important;
  /* transition: all 0.2s ease; */
}

.quality-field :deep(.v-field:hover),
.resolution-field :deep(.v-field:hover) {
  background: rgba(240, 240, 240, 0.9) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* Animation Improvements */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}

/* Responsive Design */
@media (max-width: 960px) {
  .setting-group {
    margin-bottom: 16px;
  }

  .image-header {
    padding: 16px !important;
  }

  .image-header h3 {
    font-size: 1.1rem !important;
  }
}

/* Dropdown Enhancements */
.style-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.style-select :deep(.v-list) {
  padding: 8px !important;
  background: rgba(255, 255, 255, 0.95);
}

/* Chip Enhancements */
.v-chip.v-chip--size-x-small {
  font-size: 10px !important;
  height: 20px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-chip.v-chip--size-small {
  font-size: 11px !important;
  height: 24px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Loading State */
.image-settings-container.loading {
  opacity: 0.7;
  pointer-events: none;
}

.image-settings-container.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 1;
}

.status-wrapper {
  padding: 20px;
}

.status-header {
  margin-bottom: 4px;
}

.status-display-section {
  padding: 8px 0;
}

.status-badge-container {
  margin-bottom: 8px;
}

.status-description {
  display: flex;
  align-items: center;
  opacity: 0.8;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.status-switch {
  transform: scale(1.1);
}

.switch-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-alert {
  border-radius: 12px !important;
  border: none !important;
  padding: 12px 16px !important;
}

.alert-content {
  line-height: 1.3;
}

/* Switch Styling */
.status-switch :deep(.v-switch__track) {
  width: 48px !important;
  height: 24px !important;
  border-radius: 12px !important;
}

.status-switch :deep(.v-switch__thumb) {
  width: 20px !important;
  height: 20px !important;
  border-radius: 10px !important;
}

/* Avatar animations */
.status-wrapper .v-avatar {
  transition: all 0.3s ease;
}

/* แบบเต็มหน้าจอ */
.publication-status-card-full {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
}

.status-wrapper-full {
  padding: 24px;
}
.status-wrapper-full .v-icon {
  transition: all 0.2s ease;
}

.status-header-full {
  margin-bottom: 8px;
}

.status-chip-large {
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 0 20px !important;
  height: 40px !important;
  border-radius: 20px !important;
  display: flex;
  justify-content: center;
  min-width: 150px;
}

.status-content-section {
  margin: 0 -8px;
}

.status-info-card,
.status-control-card {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.model-stats .stat-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.stat-label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.stat-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.toggle-container {
  display: flex;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(89, 150, 211, 0.03) 0%, rgba(53, 134, 216, 0.08) 100%);
}

.status-switch-large {
  transform: scale(1.3);
}
.status-switch-active :deep(.v-switch__track) {
  background-color: rgba(76, 175, 79, 0.4) !important;
}
.status-switch-active :deep(.v-switch__thumb) {
  background-color: #4caf50 !important;
  box-shadow: 0px 0px 4px rgba(47, 177, 7, 0.705);
}
.status-switch-inactive :deep(.v-switch__track) {
  box-shadow: 2px 3px 6px rgba(90, 60, 45, 0.582);
  background-color: rgba(255, 153, 0, 0.3) !important;
  border: 1px solid rgba(253, 140, 11, 0.15) !important;
}
.status-switch-inactive :deep(.v-switch__thumb) {
  background-color: #ff9800 !important;
}

.switch-label-container {
  text-align: center;
  min-width: 100px;
  display: flex;
  flex-direction: column;
}

.switch-label-large {
  font-size: 16px;
  font-weight: 600;
  display: block;
  transition: color 0.3s ease;
}
.status-control-card .switch-label-large {
  color: rgba(0, 0, 0, 0.87);
}

.switch-sublabel {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: block;
  margin-top: 4px;
}

.publish-card {
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.03) 0%, rgba(var(--v-theme-secondary), 0.01) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.publish-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(var(--v-theme-primary), 0.05), transparent);
  transition: left 0.6s ease;
}

.publish-card:hover::before {
  left: 100%;
}
/* Flow Selection Card Styling */
.flow-selection-card {
  border-radius: 16px !important;
  border: 1px solid rgba(25, 118, 210, 0.12) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.flow-selection-card:hover {
  border-color: rgba(25, 118, 210, 0.3) !important;
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.08) !important;
}

.flow-card-header {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.03) 0%, rgba(25, 118, 210, 0.08) 100%);
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.flow-selector-wrapper {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.flow-selector-wrapper:hover {
  background: rgba(255, 255, 255, 0.9);
  /* border-color: rgba(25, 118, 210, 0.3); */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Enhanced Flow Select */
.flow-select-enhanced :deep(.v-field) {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.flow-select-enhanced :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
  border-color: rgba(25, 118, 210, 0.5) !important;
}
/* Flow Selection Display */
.flow-selection-display {
  padding: 4px 0;
  width: 100%;
}

/* Flow Dropdown Items */
.flow-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
  padding: 12px 16px !important;
}

.flow-list-item:hover {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.08) 100%);
  transform: translateX(4px);
}

/* Flow Status Display */
.flow-status-display {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.flow-status-display:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.flow-status-content {
  padding: 8px 0;
}

.flow-connected,
.flow-disconnected {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Enhanced Info Button */
.info-btn-enhanced {
  position: relative;
  transition: all 0.2s ease;
}

.info-btn-enhanced:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
  transform: scale(1.1);
}

/* Dropdown Enhancements */
.flow-select-enhanced :deep(.v-overlay__content) {
  border-radius: 16px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.flow-select-enhanced :deep(.v-list) {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
}

/* Chip Animations */
.flow-connected .v-chip,
.flow-disconnected .v-chip {
  animation: chipPulse 2s ease-in-out infinite;
}

@keyframes chipPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .flow-selector-wrapper,
  .flow-status-display {
    margin-bottom: 16px;
  }

  .flow-card-header {
    padding: 16px !important;
  }

  .flow-card-header .text-h6 {
    font-size: 1.1rem !important;
  }
}

/* Icon Animations */
.flow-selection-card .v-icon {
  transition: all 0.2s ease;
}

.flow-selection-card:hover .v-icon {
  transform: scale(1.05);
}

/* Version Note Dialog */
.version-note-header {
  background: linear-gradient(135deg, #1976d2, #1565c0);
  border-radius: 4px 4px 0 0;
}
.text-white-50 {
  color: rgba(255, 255, 255, 0.7);
}

/* Version Note Dialog Actions */
.version-note-dialog .v-card-actions .gap-2 > *:not(:last-child) {
  margin-right: 8px;
}

/* Field Changes List - Scrollable Container */
.field-changes-list {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

/* Custom Scrollbar */
.field-changes-list::-webkit-scrollbar {
  width: 6px;
}

.field-changes-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.field-changes-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.field-changes-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Field Diff Cards - Compact */
.field-diff-card {
  transition: all 0.2s ease;
  border-radius: 6px;
}

.field-diff-card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateX(2px);
}

.field-diff-card .v-card-text {
  min-height: auto !important;
}

.field-diff-card.diff-added {
  border-left: 3px solid #4caf50;
  background-color: rgba(76, 175, 80, 0.02);
}

.field-diff-card.diff-modified {
  border-left: 3px solid #ff9800;
  background-color: rgba(255, 152, 0, 0.02);
}

.field-diff-card.diff-removed {
  border-left: 3px solid #f44336;
  background-color: rgba(244, 67, 54, 0.02);
}

/* Diff Value Row */
.diff-value-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 11px;
  line-height: 1.4;
  word-break: break-word;
}

.diff-value-row .v-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.diff-value-row span {
  flex: 1;
  overflow-wrap: break-word;
}
</style>
